{
  "_meta": {
    "_comment": "Phase 6 Wave 2 Task 06 — English (secondary, mirrors VI keys). vg-binding: PLAN:task-06 / P6.D-131",
    "locale": "en",
    "completeness": "secondary"
  },
  "app": {
    "name": "Printway Merchant"
  },
  "actions": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "confirm": "Confirm",
    "back": "Back",
    "submit": "Submit",
    "edit": "Edit",
    "create": "Create",
    "search": "Search",
    "filter": "Filter",
    "refresh": "Refresh",
    "loading": "Loading…",
    "processing": "Processing…",
    "retry": "Retry",
    "logout": "Log out",
    "login": "Log in",
    "copy": "Copy",
    "copied": "Copied",
    "clear": "Clear",
    "previous": "Previous",
    "next": "Next",
    "close": "Close",
    "dismiss": "Dismiss",
    "fullscreen": "Toggle fullscreen",
    "remove": "Remove",
    "collapse": "Collapse",
    "confirmDelete": "Delete \"{{name}}\"? This cannot be undone.",
    "continue": "Continue",
    "done": "Done",
    "expand": "Expand",
    "menu": "Menu",
    "prev": "Prev",
    "saveChanges": "Save changes",
    "saved": "Saved",
    "saving": "Saving…",
    "select": "Select…",
    "setDefault": "Set as default",
    "unsetDefault": "Unset default",
    "upToDate": "Up to date",
    "upload": "Upload",
    "label": "Actions",
    "enable": "Enable"
  },
  "navigation": {
    "dashboard": "Dashboard",
    "stores": "Stores",
    "products": "Products",
    "orders": "Orders",
    "shipments": "Shipment Tracking",
    "wallet": "Wallet",
    "invoices": "Invoices",
    "notifications": "Notifications",
    "support": "Support",
    "tickets": "Tickets",
    "settings": "Settings",
    "finance": "Finance",
    "team": "Team",
    "members": "Members",
    "teams": "Teams",
    "branding": "Branding",
    "sidebar": {
      "catalog": "Catalog",
      "myProducts": "My Products",
      "storeSettings": "Store Settings",
      "syncLogs": "Sync Logs",
      "billing": "Billing",
      "profile": "Profile",
      "settingsTeam": "Team",
      "settingsNotifications": "Notifications",
      "loginHistory": "Login History"
    }
  },
  "topbar": {
    "selectLanguage": "Select language",
    "selectTimezone": "Select timezone",
    "profile": "Profile",
    "theme": {
      "label": "Theme",
      "light": "Light",
      "dark": "Dark",
      "system": "System"
    },
    "balance": {
      "label": "Balance"
    },
    "outstanding": {
      "label": "Outstanding",
      "overdueBadge_one": "{{count}} overdue",
      "overdueBadge_other": "{{count}} overdue",
      "overdueBadge": "{{count}} overdue"
    },
    "help": {
      "label": "Help",
      "support": "Support / Helpdesk",
      "contact": "Contact support",
      "documentation": "Documentation",
      "email": "Email us"
    },
    "announcement": {
      "viewDetails": "View announcement details",
      "dismiss": "Dismiss",
      "previous": "Previous",
      "next": "Next"
    },
    "emailNotVerified": "Email not verified",
    "emailNotVerifiedAria": "Email not verified — open profile to resend verification",
    "walletBalance": "Wallet",
    "walletBalanceAria": "Wallet balance {{label}}",
    "notifications": {
      "title": "Notifications",
      "ariaWithCount": "Notifications ({{count}} unread)",
      "unreadCount": "{{count}} unread",
      "loading": "Loading…",
      "empty": "No notifications yet.",
      "viewAll": "View all",
      "markAllRead": "Mark all as read",
      "markReadError": "Couldn't mark as read. Please try again.",
      "reloadPrompt": "A new version is available — please refresh your browser.",
      "forbidden": {
        "title": "Notifications unavailable",
        "body": "You don't have access to a notification feed right now.",
        "retry": "Retry"
      }
    },
    "invoices": {
      "overdue": "Overdue invoices",
      "dueSoon": "Due soon invoices",
      "outstandingAria": "Outstanding invoices {{label}}"
    },
    "logoAria": "Printway home"
  },
  "banners": {
    "_comment": "Phase 6 Wave 12 Task 42 — Persistent banner copy (suspend + overdue invoice). vg-binding: PLAN:task-42 / P6.D-114 / P6.D-247 / P6.D-248 / G-70 / G-71",
    "suspend": {
      "title": "Account suspended",
      "message": "Your account is suspended. Contact Admin Support to restore.",
      "contact": "Contact Support"
    },
    "overdue": {
      "title_one": "1 invoice overdue",
      "title_other": "{{count}} invoices overdue",
      "cta": "Pay now",
      "dismiss": "Dismiss"
    }
  },
  "mutationGuard": {
    "_comment": "Phase 6 Wave 12 Task 42 — Mutation lockdown copy. vg-binding: PLAN:task-42 / P6.D-114 / P6.D-248",
    "disabled": "Action disabled — account suspended",
    "error": "Cannot perform this action while suspended"
  },
  "suspended": {
    "title": "Account suspended",
    "body": "Please contact Support for assistance.",
    "shortLabel": "Suspended — contact Support."
  },
  "auth": {
    "_comment": "Phase 6 Wave 12 Task 43 — adds forgotPassword + resetPassword sub-namespaces. vg-binding: PLAN:task-43 / P6.D-184 / P6.D-130",
    "title": "Sign in to continue",
    "email": "Email",
    "password": "Password",
    "remember": "Remember me",
    "forgot": "Forgot password?",
    "submit": "Log in",
    "submitting": "Processing…",
    "twofa": {
      "prompt": "Open your authenticator app and enter the 6-digit code.",
      "label": "Authentication code (TOTP)",
      "submit": "Verify"
    },
    "errors": {
      "invalidEmail": "Invalid email address.",
      "missingEmail": "Please enter your email.",
      "missingPassword": "Please enter your password.",
      "shortPassword": "Password must be at least 8 characters.",
      "invalidTotp": "The TOTP code must be 6 digits.",
      "invalidCredentials": "Email or password is incorrect.",
      "accountLockedTitle": "Account temporarily locked.",
      "accountLockedBody": "5 failed attempts in a row — try again in {{countdown}} or reset your password via email.",
      "rateLimited": "Too many requests. Please try again in a moment.",
      "network": "Cannot reach the server. Please try again."
    },
    "forgotPassword": {
      "title": "Forgot password",
      "subtitle": "Enter your account email — we will send a reset link.",
      "email": "Email",
      "submit": "Send reset link",
      "backToLogin": "← Back to login",
      "sentSuccess": {
        "title": "Email sent (if it exists)",
        "message": "If the email exists, a reset link has been sent.",
        "hint": "Didn't get it? Check your spam folder, or the email may not be registered — you can create a new account."
      },
      "headingFull": "Forgot your password?",
      "helperFull": "Enter your email address and we'll send you instructions to reset your password.",
      "login": "Login",
      "remember": "Remember your password?",
      "submitFull": "Send Reset Instructions",
      "submittingFull": "Sending…"
    },
    "resetPassword": {
      "title": "Reset password",
      "subtitle": "Enter a new password for your account.",
      "newPassword": "New password",
      "confirmPassword": "Confirm new password",
      "submit": "Reset password",
      "success": "Password reset. Redirecting to login…",
      "tokenInvalid": "This reset link has expired or is invalid. Please request a new one.",
      "requestNew": "→ Request a new link"
    },
    "footnote": "Your session is protected by a secure cookie.",
    "login": {
      "_comment": "Phase 6 i18n batch M1 — Marketing decor panel on LoginPage right column. vg-binding: P6.D-131 / P6.D-221",
      "marketing": {
        "workspaceBadge": "Merchant workspace",
        "ordersTitle": "Today's orders",
        "live": "Live",
        "orders": "Orders",
        "onTime": "On time",
        "wallet": "Wallet",
        "syncQueue": "Sync queue",
        "productsReady": "{{count}} products ready",
        "billing": "Billing",
        "billingClear": "Clear",
        "noOverdue": "No overdue invoices"
      },
      "heading": "Welcome back",
      "noAccount": "New to Printway?",
      "submit": "Sign in",
      "submitting": "Signing in…"
    },
    "register": {
      "_comment": "Phase 6 i18n batch M1 — RegisterPage country select options + existing register sub-keys. vg-binding: P6.D-131 / P6.D-221 / P6.D-253",
      "countries": {
        "VN": "Vietnam (VN)",
        "US": "United States (US)",
        "GB": "United Kingdom (GB)",
        "AU": "Australia (AU)",
        "CA": "Canada (CA)",
        "FR": "France (FR)",
        "DE": "Germany (DE)"
      },
      "countryLabel": "Country",
      "email": "Email",
      "errors": {
        "emailRequired": "Please enter a valid email.",
        "passwordTooShort": "Password must be at least 12 characters.",
        "displayNameRequired": "Please enter a display name.",
        "countryRequired": "Please select a country.",
        "acceptTermsRequired": "You must accept the terms of service.",
        "emailTaken": "This email is already registered. Log in instead.",
        "invalid": "Please check your details.",
        "rateLimit": "Too many requests. Try again in a few minutes.",
        "generic": "Registration failed. Please try again.",
        "passwordMismatch": "Passwords do not match."
      },
      "title": "Create account",
      "subtitle": "Sign up to start selling print-on-demand products on Printway.",
      "password": "Password",
      "displayName": "Display name",
      "acceptTerms": "I agree to the terms of service and privacy policy.",
      "submit": "Sign up",
      "alreadyHaveAccount": "Already have an account?",
      "loginLink": "Log in",
      "passwordHint": "(minimum 12 characters)",
      "confirmPassword": "Confirm password"
    },
    "emailPlaceholder": "your@email.com",
    "marketing": {
      "subtitle": "Join thousands of entrepreneurs selling custom products with Printway",
      "title": "Start your POD business today"
    },
    "or": "OR",
    "registerCta": "Sign Up",
    "sso": {
      "google": "Continue with Google",
      "lark": "Continue with Lark Suite"
    },
    "verifyEmail": {
      "errors": {
        "invalid": "Incorrect OTP code. Please try again.",
        "expired": "OTP code expired. Tap \"Resend\" to get a new one.",
        "rateLimit": "Too many attempts. Please wait.",
        "generic": "Verification failed. Please try again.",
        "resendRateLimit": "Please wait before resending.",
        "resendGeneric": "Failed to resend OTP. Try again later."
      },
      "resendSuccess": "OTP code resent. Please check your email.",
      "missingEmailTitle": "No email to verify",
      "missingEmailBody": "Please go back to the registration page.",
      "backToRegister": "← Sign up",
      "title": "Verify email",
      "subtitle": "We sent a 6-digit code to:",
      "otpLabel": "6-digit OTP code",
      "submit": "Verify",
      "didNotReceive": "Didn't receive the code?",
      "resend": "Resend",
      "backToLogin": "← Log in",
      "resendCooldown": "Resend ({{n}}s)"
    }
  },
  "currency": {
    "tooltip": "Source of truth: USD. Rate: {{rate}} {{display}}/USD @ {{fetchedAt}}.",
    "fallback": "Showing USD — exchange rate temporarily unavailable."
  },
  "datetime": {
    "justNow": "Just now",
    "secondsAgo": "{{count}} seconds ago",
    "minutesAgo": "{{count}} minutes ago",
    "hoursAgo": "{{count}} hours ago",
    "daysAgo": "{{count}} days ago",
    "yesterday": "Yesterday",
    "tomorrow": "Tomorrow",
    "in": "{{value}}"
  },
  "errors": {
    "403": {
      "code": "403",
      "title": "Access denied",
      "subtitle": "Your account does not have permission to view this page. Contact an administrator if you believe this is a mistake.",
      "contactAdmin": "Contact admin"
    },
    "404": {
      "code": "404",
      "title": "Page not found",
      "subtitle": "The page you are looking for does not exist or has been moved.",
      "backHome": "Back to home"
    },
    "500": {
      "code": "500",
      "title": "Server is having trouble",
      "subtitle": "Your request did not complete. Please try again in a moment.",
      "retry": "Retry",
      "statusPage": "Status page"
    },
    "_comment": "Phase 6 Wave 12 Task 43 — adds 404/403/500 dedicated error-page copy. vg-binding: PLAN:task-43 / P6.D-204",
    "generic": "Something went wrong. Please try again.",
    "network": "Connection lost — check your network and retry.",
    "unauthorized": "Your session has expired. Please sign in again.",
    "forbidden": "You don't have permission to perform this action.",
    "validation": "Invalid input. Check the highlighted fields.",
    "rate_limited": "Too many requests — try again in a moment.",
    "server": "Server is currently unavailable. Please try again.",
    "fx_provider_unavailable": "Exchange rate temporarily unavailable. Showing USD.",
    "maintenance": {
      "title": "Under maintenance",
      "subtitle": "The platform is under maintenance. Please check back in a few minutes.",
      "retry": "Retry"
    }
  },
  "promo": {
    "_comment": "Phase 6 Wave 12 Task 43 — Promo banner copy (P6.D-222). vg-binding: PLAN:task-43 / P6.D-222 / G-72",
    "dismiss": "Dismiss",
    "cta": "Learn more"
  },
  "security": {
    "_comment": "Phase 6 Wave 12 Task 43 — Suspend overlay copy (P6.D-114). vg-binding: PLAN:task-43 / P6.D-114",
    "suspend": {
      "overlay": {
        "title": "Account suspended",
        "body": "Access restricted. Contact Admin Support.",
        "cta": "Contact Support"
      }
    }
  },
  "artwork": {
    "nav": {
      "label": "Artwork library"
    },
    "empty": "No files in this folder yet.",
    "folder": {
      "new": "+ New folder",
      "root": "All artwork",
      "collapse": "Collapse",
      "expand": "Expand"
    },
    "view": {
      "grid": "Grid",
      "list": "List",
      "listAria": "List view",
      "gridAria": "Grid view"
    },
    "list": {
      "colThumb": "Thumb",
      "colName": "Name",
      "colSize": "Size",
      "colUploaded": "Uploaded",
      "colUsed": "Used"
    },
    "upload": {
      "trigger": "Upload",
      "dropHere": "Drop files here or click to browse",
      "browse": "Click to browse",
      "maxSizeSync": "Sync ≤10MB",
      "async": "Async >10MB",
      "maxFiles": "Upload at most {{max}} images at a time.",
      "tooLarge": "Image exceeds 100MB."
    },
    "bulk": {
      "selectedCount": "{{count}} selected",
      "move": "Move",
      "delete": "Delete",
      "downloadZip": "Download ZIP",
      "deleteError": "Could not delete artwork. Please try again.",
      "deleteSuccess": "Deleted {{count}} artwork.",
      "moveError": "Could not move artwork. Please try again.",
      "moveSuccess": "Moved {{count}} artwork to {{folder}}.",
      "needSelection": "Select artwork first (tick the checkbox at the top-left of the card).",
      "deleteSuccess_one": "Deleted {{count}} artwork.",
      "deleteSuccess_other": "Deleted {{count}} artworks.",
      "moveSuccess_one": "Moved {{count}} artwork to {{folder}}.",
      "moveSuccess_other": "Moved {{count}} artworks to {{folder}}."
    },
    "lightbox": {
      "metadata": "File metadata",
      "dpi": "DPI",
      "dimensions": "Dimensions",
      "format": "Format",
      "size": "Size",
      "uploaded": "Uploaded",
      "usedIn": "Used in products",
      "usedInEmpty": "Not used yet.",
      "download": "Download",
      "edit": "Edit",
      "rename": "Rename",
      "move": "Move",
      "delete": "Delete",
      "prev": "Previous",
      "next": "Next",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "rootFolder": "(root)",
      "ok": "OK"
    },
    "editor": {
      "title": "Edit artwork",
      "crop": "Crop",
      "rotate": "Rotate",
      "resize": "Resize",
      "reset": "Reset",
      "save": "Save",
      "saving": "Saving...",
      "savedToast": "Saved as new artwork",
      "saveErrorToast": "Failed to save artwork",
      "cropHint": "Drag to select crop region",
      "widthLabel": "Width (px)",
      "heightLabel": "Height (px)",
      "mockupOverlayNote": "Mockup preview is static — interactive positioning in Advanced Editor (coming soon)"
    },
    "badge": {
      "embroidery": "Embroidery",
      "new": "NEW",
      "usedIn": "Used {{count}}"
    },
    "quota": {
      "label": "Used: {{used}} / {{limit}}",
      "warn80": "Storage usage above 80% — consider clearing old files.",
      "warn90": "Storage usage above 90% — almost full!",
      "blocked": "Storage is full. Uploads are disabled."
    },
    "mapping": {
      "suggest": "Map to Order #{{orderNumber}}?"
    },
    "grid": {
      "selectAria": "Select {{name}}"
    },
    "folderPicker": {
      "count": "{{shown}} / {{total}} folder",
      "title": "Move {{count}} artwork to folder",
      "subtitle": "Choose a destination folder, or Root to remove from any folder.",
      "search": "Search folders by name…",
      "noMatch": "No matching folders.",
      "empty": "No folders yet — create one in the sidebar.",
      "hint": "Tip: double-click to select quickly.",
      "confirm": "Move here",
      "title_one": "Move {{count}} artwork to a folder",
      "title_other": "Move {{count}} artworks to a folder"
    },
    "batch": {
      "error": "Upload batch not found.",
      "progress": "{{succeeded}}/{{total}} done · {{failed}} failed",
      "fileError": "Invalid file.",
      "title": "Upload batch ({{count}} files)",
      "title_one": "Upload batch ({{count}} file)",
      "title_other": "Upload batch ({{count}} files)"
    },
    "move": {
      "error": "Could not move artwork. Please try again.",
      "success": "Moved artwork to {{folder}}"
    }
  },
  "orders": {
    "_comment": "Phase 6 Wave 6 Task 17 — Orders list page copy. vg-binding: PLAN:task-17 / P6.D-40 / P6.D-41 / P6.D-42 / P6.D-43 / P6.D-47 / P6.D-48",
    "artwork": {
      "_comment": "Phase 4.9 Wave 5 Task 14 — order-import artwork-ingest copy. vg-binding: PLAN:task-14 / P4.9.D-18 / P4.9.D-19 / P4.9.D-20",
      "section": {
        "title": "Artwork ingest"
      },
      "aggregate": {
        "processing": "Processing artwork",
        "ready": "Artwork ready",
        "error": "Artwork error"
      },
      "status": {
        "pending": "Pending",
        "downloading": "Downloading",
        "validating": "Validating",
        "retrying": "Retrying",
        "validated": "Validated",
        "error": "Error"
      },
      "action": {
        "editLink": "Edit link",
        "reIngest": "Re-download",
        "manualUpload": "Upload manually",
        "unauthorized": "Please sign in again to continue.",
        "forbidden": "You do not have permission to act on this order."
      },
      "error": {
        "GENERIC": "The artwork could not be processed.",
        "ARTWORK_LINK_UNREACHABLE": "The artwork link could not be reached. Check the URL and access.",
        "ARTWORK_FILE_TOO_LARGE": "The artwork file is too large.",
        "ARTWORK_EXTENSION_INVALID": "The artwork file type is not supported.",
        "ARTWORK_DIMENSION_MISMATCH": "The artwork dimensions do not match the print area.",
        "ARTWORK_DPI_TOO_LOW": "The artwork resolution (DPI) is too low for printing.",
        "ARTWORK_DECODE_FAILED": "The artwork file could not be decoded.",
        "ARTWORK_SSRF_REJECTED": "The artwork link points to a blocked address.",
        "ARTWORK_TEMPLATE_MISSING": "The print template for this area is missing.",
        "ARTWORK_SYSTEM_ERROR": "An unexpected error occurred while processing the artwork."
      },
      "thumb": {
        "alt": "Artwork thumbnail",
        "openPreview": "Open preview"
      },
      "preview": {
        "alt": "Artwork preview"
      },
      "polling": {
        "timeout": "Check back later — refresh"
      },
      "editLink": {
        "title": "Update artwork link",
        "body": "Paste a new public link for this print area. We will re-download and validate it.",
        "label": "Artwork link",
        "submit": "Update & re-download",
        "saving": "Saving…"
      },
      "link": {
        "updated": "Link updated and re-download queued."
      },
      "reingest": {
        "queued": "Re-download queued."
      },
      "upload": {
        "queued": "Artwork uploaded and re-validation queued."
      },
      "filter": {
        "label": "Artwork status",
        "activeLabel": "Filtered by artwork status:"
      },
      "original": {
        "alt": "Original artwork",
        "badge": "Original"
      },
      "requiredSpecs": "Required: ",
      "actualSpecs": "Actual: ",
      "requiredVsActual": "required {{required}} · actual: {{actual}}"
    },
    "create": {
      "_comment": "Phase 6 Wave 6 Task 19 — Order Create Wizard copy. vg-binding: PLAN:task-19 / P6.D-52..58 / P6.D-60 / P6.D-61 / G-34",
      "title": "Create order",
      "type": {
        "basic": "Basic",
        "sample": "Sample",
        "bulk": "Bulk"
      },
      "bulkType": {
        "fba": "FBA",
        "fbt": "FBT",
        "general": "General"
      },
      "step": {
        "products": "Products",
        "design": "Design",
        "checkout": "Checkout"
      },
      "context": {
        "store": {
          "label": "Store",
          "placeholder": "Select store…",
          "auto": "Auto-selected",
          "locked": "Store is fixed while editing or reordering",
          "changeTitle": "Change store?",
          "changeBody": "Switching store clears the current cart — products belong to the selected store.",
          "changeConfirm": "Change store"
        },
        "type": {
          "label": "Order type",
          "basic": "Basic",
          "sample": "Sample",
          "bulk": "Bulk"
        },
        "bulkType": {
          "label": "Bulk type"
        },
        "gate": {
          "store": "Select a store to continue",
          "sampleReason": "Pick a sample reason to continue",
          "bulkType": "Pick a bulk type to continue"
        }
      },
      "products": {
        "selectProducts": "Select Products",
        "modal": {
          "title": "Select Products",
          "searchPlaceholder": "Search products…",
          "category": "Category",
          "collection": "Collection",
          "location": "Fulfillment location",
          "allCategories": "All categories",
          "allCollections": "All collections",
          "allLocations": "All locations",
          "loading": "Loading…",
          "loadError": "Could not load products. Please try again.",
          "noResults": "No products match these filters.",
          "fromPrice": "From {{price}}",
          "variantCount": "{{count}} variants",
          "selectedCount": "{{count}} products selected",
          "selectHint": "Select one or more products to continue.",
          "cancel": "Cancel",
          "startOrder": "Start Order",
          "filterUnavailable": "Unavailable",
          "filtersError": "Some filters could not be loaded. Browsing and search still work.",
          "search": "Search",
          "tabs": {
            "myProducts": "My products",
            "catalog": "Catalog"
          },
          "myProducts": {
            "empty": "No products of yours match these filters.",
            "browseCatalog": "Browse catalog",
            "locked": "No longer available to order",
            "noBlueprint": "Base product no longer available",
            "droppedUnavailable_one": "{{count}} selected product is no longer orderable and was removed.",
            "droppedUnavailable_other": "{{count}} selected products are no longer orderable and were removed."
          }
        },
        "page": {
          "title": "Create Order",
          "subtitle": "Finalize shipping options and submit your customer's shipment details",
          "store": "Store",
          "storePlaceholder": "Select store…",
          "storeLoading": "Loading stores…",
          "storeChangeTitle": "Change store?",
          "storeChangeBody": "Switching store clears the products already added to this order.",
          "addProduct": "Add Product",
          "shipping": "Shipping",
          "pay": "Pay",
          "orderName": "Order Name",
          "orderNamePlaceholder": "ORD-2024-001"
        },
        "cart": {
          "empty": "No products in this order yet."
        },
        "line": {
          "location": "Location",
          "qty": "Qty",
          "itemCost": "Item cost",
          "total": "Total",
          "note": "Note",
          "notePlaceholder": "Add specific delivery instructions here...",
          "loadingVariants": "Loading variants…",
          "noLocation": "No location available",
          "variantsError": "Could not load this product's variants.",
          "variantUnavailable": "This combination is not available — pick different options to continue.",
          "noPrintAreas": "This product has no print area configured.",
          "myProductUnavailable": "This product can no longer be ordered. Remove it to continue.",
          "myProductLoadError": "Could not load this product.",
          "retry": "Retry",
          "artworkDetached_one": "{{count}} artwork file doesn't fit this variant's print areas and was removed from the line. It is still in your library.",
          "artworkDetached_other": "{{count}} artwork files don't fit this variant's print areas and were removed from the line. They are still in your library."
        },
        "artwork": {
          "uploaded": "Artwork added",
          "uploadFailed": "Upload failed",
          "rejected": "File rejected"
        },
        "subtotal": "Subtotal"
      },
      "artwork": {
        "assign": {
          "fromLibrary": "From library",
          "upload": "Upload new",
          "remove": "Remove"
        },
        "assigned": "Assigned",
        "unassigned": "Unassigned",
        "incomplete": "Artwork must be assigned to all required print areas",
        "libraryPicker": {
          "title": "Choose artwork from library",
          "search": "Search by name…",
          "empty": "Library is empty. Upload artwork at /artwork or use the \"Upload new\" button.",
          "noMatch": "No matching artwork.",
          "confirm": "Select"
        },
        "required": "Required",
        "optional": "Optional",
        "choose": {
          "title": "Choose artwork",
          "uploadTitle": "Click or drag file to this area to upload",
          "search": "Search by Artwork's name",
          "empty": "No artwork yet — upload one above.",
          "noMatch": "No artwork matches that name.",
          "listError": "Could not load your artwork library.",
          "wrongSize": "{{actual}} ≠ required {{required}}",
          "apply": "Apply to {{area}}"
        }
      },
      "shipping": {
        "field": {
          "name": "Full Name",
          "line1": "Address 1",
          "line2": "Address 2 (Optional)",
          "city": "City",
          "state": "State",
          "postalCode": "ZipCode",
          "country": "Country",
          "phone": "Phone Number",
          "email": "Email",
          "line2Placeholder": "Apartment, suite, unit...",
          "taxNumber": "Tax Number",
          "note": "Note",
          "notePlaceholder": "Add specific delivery instructions here..."
        },
        "validate": {
          "button": "Validate",
          "valid": "Valid",
          "warn": "Warning",
          "invalid": "Invalid"
        },
        "suggestion": {
          "apply": "Apply suggestion"
        },
        "gps": {
          "button": "Use current location"
        },
        "fba": {
          "warehouse": "FBA warehouse",
          "fnsku": "FNSKU"
        },
        "search": {
          "country": "Search country…",
          "state": "Search state/province…",
          "city": "Search city…"
        },
        "state": {
          "none": "No state/province"
        },
        "method": {
          "label": "Shipping method",
          "merchant": "Ship by merchant",
          "merchantDesc": "Merchant ships — enter the delivery address.",
          "tiktok": "Marketplace label",
          "tiktokDesc": "Upload the label provided by the marketplace (TikTok, Etsy…) — no address needed.",
          "loading": "Loading shipping options…",
          "none": "Enter a delivery address to see the available shipping options.",
          "sampleFree": "Sample orders ship free — no shipping fee is charged."
        },
        "label": {
          "title": "Upload shipping label",
          "help": "PDF or image. The label already carries the recipient info, so no address is required.",
          "modeUpload": "Upload file",
          "modeLink": "Enter link",
          "missingUpload": "Choose a label file to continue.",
          "missingLink": "Paste a label link to continue."
        },
        "country": "Country",
        "line1": "Address line 1",
        "line2": "Address line 2 (optional)",
        "phone": "Phone",
        "postal": "Postal code",
        "rate": {
          "calculating": "Calculating rates…",
          "eta": "{{min}}–{{max}} business days",
          "title": "Shipping rate",
          "fillAddress": "Enter the full address (line 1, city, country) to see shipping methods + rates."
        },
        "recipient": "Recipient name",
        "infoTitle": "Shipping Information",
        "methodTitle": "Shipping Method",
        "sampleCountryLocked": "Sample orders ship to our Vietnam facility."
      },
      "review": {
        "subtotal": "Subtotal",
        "shipping": "Shipping",
        "tax": "Tax",
        "embroideryCost": "Embroidery",
        "total": "Total",
        "title": "Review order",
        "table": {
          "product": "Product",
          "variant": "Variant",
          "qty": "Qty",
          "artwork": "Artwork",
          "subtotal": "Subtotal"
        },
        "embroidery": {
          "title": "Embroidery options",
          "threadColor": "Thread color",
          "position": "Position",
          "digitizingFee": "Digitizing fee"
        },
        "continueToPayment": "Continue to Payment",
        "customer": "Customer",
        "itemsTitle": "Order Items ({{count}})",
        "noCustomer": "No customer info",
        "qtyLine": "Qty: {{qty}} × {{price}}",
        "saveOnly": "Save order (pay later)",
        "shippingAddress": "Shipping Address",
        "summaryTitle": "Order Summary",
        "taxPct": "Tax ({{pct}})",
        "tiktokAddress": "Marketplace label (no address)",
        "artworkChecking": "Checking artwork requirements…",
        "artworkRequired": "Artwork is required for these print areas: {{areas}}. Go back to the Artwork step to finish."
      },
      "nav": {
        "next": "Next",
        "back": "Back",
        "save_draft": "Save draft"
      },
      "orderType": {
        "sampleReason": {
          "label": "Sample reason (required)",
          "quality": "Quality check",
          "colorMatch": "Color match",
          "proofApproval": "Proof approval",
          "marketing": "Marketing photos",
          "other": "Other"
        }
      },
      "orderName": {
        "label": "Order name",
        "uniqueHint": "must be unique — no duplicates",
        "placeholder": "e.g. PO-2025-001 / John batch 1",
        "help": "Required — used as your internal reference (PO number, customer name…). One unique name per order."
      },
      "design": {
        "skipHint": "Create or adjust artwork here, or skip — you can upload per print area in the Artwork step.",
        "badge": {
          "newProduct": "New product — artwork needed",
          "personalized": "Personalized — fresh artwork required",
          "fromProduct": "Artwork from product"
        },
        "noMockup": "No mockup preview available",
        "editBtn": "Edit",
        "editor": {
          "title": "Design Maker",
          "noArtwork": "No artwork selected"
        }
      },
      "confirm": {
        "title": "Order Confirmation",
        "discount": "Discount Code",
        "discountPlaceholder": "Enter discount code",
        "discountSoon": "Discount codes are not available yet.",
        "apply": "Apply",
        "summary": "Order Summary",
        "subtotal": "Subtotal ({{count}} items)",
        "shippingFee": "Shipping fee",
        "taxFee": "Tax fee",
        "surcharge": "Total surcharge",
        "surchargeSoon": "Surcharges are not itemised yet.",
        "total": "Total",
        "paymentMethod": "Payment Method",
        "payLater": "Pay later",
        "payLaterHint": "Create the order now and pay from its page.",
        "wallet": "Printway Wallet",
        "credit": "Printway Credit",
        "balance": "Balance: {{balance}}",
        "walletShort": "Balance: {{balance}} — not enough",
        "creditSoon": "not available yet",
        "terms": "I agree to the terms and conditions",
        "submit": "Create Order",
        "submitting": "Creating…",
        "blocked": "The price is not ready yet. Please wait a moment.",
        "failed": "Could not create the order. Please try again.",
        "paidTitle": "Order confirmed",
        "draftTitle": "Order created",
        "draftBody": "You can pay for it any time from the order page.",
        "termsPrefix": "I agree to the",
        "termsLink": "Term & Condition"
      },
      "validation": {
        "required": "This field is required",
        "emailInvalid": "Enter a valid email address",
        "phoneInvalid": "Enter a valid phone number",
        "storeRequired": "Select the store this order belongs to",
        "noLines": "Add at least one product",
        "unresolvedVariant": "Every product needs a variant selected",
        "artworkRequired": "Upload artwork for every required print area",
        "artworkAreasMissing": "Upload artwork for: {{areas}}",
        "methodRequired": "Choose a shipping method",
        "orderNameRequired": "Enter a name for this order",
        "productUnavailable": "A product can no longer be confirmed for ordering — retry or remove it",
        "productLoading": "Checking your products — try again in a moment"
      }
    },
    "import": {
      "_comment": "Phase 6 Wave 6 Task 20 — Excel Import wizard copy. vg-binding: PLAN:task-20 / P6.D-62 / P6.D-63 / G-35",
      "navLabel": "Excel import",
      "title": "Excel import",
      "step": {
        "upload": "Upload",
        "matching": "Matching",
        "review": "Review",
        "payment": "Payment",
        "result": "Result",
        "aria": "Import steps",
        "downloadFailed": "Download failed",
        "uploadFailed": "Upload failed",
        "presetLoadFailed": "Preset load failed",
        "saveFailed": "Save failed",
        "quoteFailed": "Quote failed",
        "commitFailed": "Commit failed"
      },
      "upload": {
        "dropHere": "Drop XLSX/CSV...",
        "templateDownload": "Download template",
        "button": "Upload",
        "uploading": "Uploading...",
        "invalidType": "Unsupported file type",
        "xlsxNote": "Preview after server processing"
      },
      "matching": {
        "title": "Map columns",
        "preset": {
          "label": "Preset",
          "save": "Save preset",
          "namePrompt": "Preset name:"
        },
        "col": {
          "field": "Printway field",
          "column": "File column"
        },
        "field": {
          "orderNumber": "Order number",
          "customerName": "Customer name",
          "customerEmail": "Customer email",
          "addressLine1": "Address line 1",
          "city": "City",
          "state": "State / Province",
          "postalCode": "Postal code",
          "country": "Country",
          "productSku": "Product SKU",
          "qty": "Quantity",
          "artworkUrl_print_area_1": "Artwork URL — area 1",
          "artworkUrl_print_area_2": "Artwork URL — area 2",
          "embroidery_thread_color": "Embroidery thread color"
        }
      },
      "review": {
        "errorsOnly": "Errors only",
        "empty": "No rows to display",
        "totals": {
          "orders": "Total orders",
          "errors": "Errors",
          "estimated": "Estimated total",
          "grouped": "{{rows}} rows → {{orders}} orders (grouped by order_name)"
        }
      },
      "payment": {
        "method": {
          "wallet": "Wallet",
          "cc": "Credit card",
          "paypal": "PayPal",
          "payLater": "Pay later"
        },
        "batchNote": "Single transaction for the entire batch",
        "payLaterNote": "Orders will be created as unpaid drafts — pay each order later from the Orders list.",
        "commit": "Commit batch",
        "committing": "Committing..."
      },
      "result": {
        "success": "Succeeded: {{count}}",
        "failed": "Failed: {{count}}",
        "errorsDownload": "Download error CSV",
        "orderIds": "Created orders",
        "restart": "Import another batch"
      },
      "progress": {
        "percent": "{{pct}}% — {{processed}}/{{total}} orders"
      },
      "nav": {
        "next": "Next",
        "back": "Back"
      },
      "action": "Import"
    },
    "nav": {
      "label": "Orders"
    },
    "list": {
      "title": "Orders",
      "emptyState": {
        "noMatchFilter": "No orders match the current filter."
      },
      "error": {
        "loadFailed": "Failed to load orders"
      },
      "dateRange": {
        "last7": "Last 7 days",
        "last30": "Last 30 days",
        "last90": "Last 90 days",
        "allTime": "All time",
        "from": "From",
        "to": "To",
        "done": "Done"
      },
      "bulkDiscount": {
        "itemsOrdered": "Items ordered",
        "itemsThreshold": "10+ items",
        "shipping": "Shipping discount",
        "shippingValue": "Up to 10%",
        "product": "Product discount",
        "productValue": "Up to 5%"
      },
      "store": {
        "manual": "Manual Order",
        "all": "All stores",
        "search": "Search stores…"
      },
      "cancelConfirm_one": "Cancel this {{count}} order?",
      "cancelConfirm_other": "Cancel {{count}} orders?",
      "createOrder": "Create Order",
      "createTicket": "Create Ticket",
      "sound": {
        "on": "New-order sound: On",
        "off": "New-order sound: Off"
      },
      "dateRangePicker": "Date range",
      "paymentFilter": "Payment status",
      "productFilter": {
        "label": "Product Type",
        "selected": "Product",
        "empty": "No products found",
        "search": "Search products"
      },
      "statusFilter": "Status",
      "storeFilter": "Store",
      "tabsLabel": "Order status",
      "cancelConfirm": "Cancel {{count}} orders?",
      "sendToProduction": {
        "cta": "Send to production",
        "sending": "Sending…",
        "success": "Order sent to production.",
        "tooltipSend": "Send this order to the vendor to begin production.",
        "tooltipNotWaiting": "Only paid orders awaiting approval can be sent to production."
      },
      "bulkSend": {
        "success": "{{assigned}} sent to production, {{blocked}} blocked.",
        "error": "Bulk send failed. Please try again."
      },
      "bulkSendResult": {
        "title": "Send to production results",
        "summary": "{{assigned}} sent · {{blocked}} blocked · {{total}} total",
        "assigned": "Sent to production",
        "blocked": "Blocked",
        "itemsAssigned": "{{count}} item(s) assigned",
        "close": "Close",
        "orderLabel": "Order {{id}}",
        "reason": {
          "ARTWORK_NOT_VALIDATED": "Artwork not validated",
          "FORBIDDEN_TENANT": "Not permitted",
          "INVALID_STATE": "Not in a sendable state",
          "NOT_FOUND": "Order not found",
          "unknown": "Blocked"
        }
      },
      "shippingNameSearch": "Ship to",
      "moreFilters": "More filters",
      "sourceTabsLabel": "Order source",
      "sourceTab": {
        "my": "My Orders",
        "external": "External Orders"
      },
      "orderSearch": "Order ID",
      "dateFrom": "From {{date}}",
      "dateUntil": "Until {{date}}",
      "filter": {
        "statusAll": "Status: All",
        "clearHint": "Click again to clear"
      },
      "shippingStatusFilter": "Shipping status",
      "shipping": {
        "merchant": "Merchant",
        "tiktokLabel": "TikTok label"
      },
      "creationTypeFilter": "Creation type",
      "creation": {
        "merchant": "Merchant dashboard",
        "admin": "Admin",
        "api": "API",
        "other": "Other"
      }
    },
    "tab": {
      "all": "All",
      "draft": "Draft",
      "pending": "Pending",
      "processing": "Processing",
      "shipped": "Shipped",
      "delivered": "Delivered",
      "issues": "Issues",
      "unverified": "Unverified",
      "waiting": "Waiting Approval",
      "late": "Late"
    },
    "search": {
      "placeholder": "Search by order #, name, customer, email…",
      "recent": "Recent"
    },
    "bulk": {
      "_comment": "Phase 6 Wave 6 Task 21 — Bulk actions popup keys appended.",
      "selectedCount": "{{count}} selected",
      "cancel": "Cancel orders",
      "export": "Export CSV",
      "maxWarn": "Max 200 orders per bulk action",
      "title": "Bulk actions",
      "actionLabel": "Action",
      "tagLabel": "Tag value",
      "tagRequired": "Enter a tag value",
      "moreActions": "More actions",
      "maxLabel": "{{n}} selected (max 200)",
      "partialToast": "{{ok}}/{{total}} succeeded, {{fail}} failed",
      "action": {
        "cancel": "Cancel",
        "export": "Export",
        "retag": "Re-tag",
        "markShipped": "Mark shipped",
        "retrigger": "Re-trigger"
      },
      "confirm": {
        "cancel": "Cancel {{n}} order(s)?",
        "export": "Export {{n}} order(s) as CSV?",
        "retag": "Apply tag to {{n}} order(s)?",
        "markshipped": "Mark {{n}} order(s) as shipped?",
        "retrigger": "Re-trigger fulfilment for {{n}} order(s)?"
      },
      "actionFailed": "Bulk action failed",
      "pay": {
        "confirmBody": "{{count}} order(s) — {{amount}} total. Choose how to pay below.",
        "confirmCta": "Confirm payment",
        "confirmTitle": "Pay selected orders?",
        "cta": "Pay",
        "genericError": "Payment failed",
        "maxCap": "Max {{n}} orders per payment.",
        "onlyUnpaid": "Only unpaid orders can be paid — deselect the rest.",
        "processing": "Paying…",
        "resultFailedHeading": "Payment failed ({{n}}):",
        "resultPaidList": "Paid: {{list}}",
        "singleCurrency": "Select orders of a single currency to pay together.",
        "funding": {
          "label": "Pay with",
          "creditInsufficient": "Not enough credit for this batch ({{amount}} left)"
        }
      },
      "sendToProduction": {
        "cta": "Send to production",
        "onlyWaiting": "Only paid Waiting Approval orders can be sent — deselect the rest."
      },
      "cancelHint": {
        "onlyPreProduction": "Only pre-approval orders (Draft / Waiting Approval) can be cancelled. Orders already In Production cannot be cancelled — deselect them."
      }
    },
    "advancedFilter": {
      "_comment": "Phase 6 Wave 6 Task 21 — Advanced filter composer.",
      "title": "Advanced filter",
      "addRule": "Add rule",
      "apply": "Apply",
      "field": "Field",
      "operator": "Operator",
      "value": "Value",
      "logic": "Logic",
      "operator.eq": "equals",
      "operator.ne": "not equals",
      "operator.gt": "greater than",
      "operator.gte": "greater or equal",
      "operator.lt": "less than",
      "operator.lte": "less or equal",
      "operator.contains": "contains",
      "operator.in": "in",
      "operator.notIn": "not in",
      "operator.between": "between",
      "logicOp": {
        "AND": "AND",
        "OR": "OR",
        "WHERE": "WHERE"
      }
    },
    "customView": {
      "_comment": "Phase 6 Wave 6 Task 21 — Orders custom views page.",
      "nav": "Custom views",
      "create": "Create new view",
      "edit": "Edit view",
      "savedViews": "Saved views",
      "empty": "No saved views yet.",
      "selectOrCreate": "Select a view to edit or create a new one.",
      "save": "Save view",
      "delete": "Delete",
      "apply": "Apply",
      "public": "Public",
      "private": "Private",
      "noFilters": "No filters",
      "filterCount": "{{n}} rules",
      "archive": "Archive",
      "archiveDesc": "Auto-cancelled orders swept to archive",
      "field": {
        "name": "Name",
        "description": "Description",
        "columns": "Columns",
        "filters": "Filters",
        "public": "Public (visible to all merchants)",
        "shareWith": "Share with merchants (comma-separated ids)"
      },
      "error": {
        "loadFailed": "Failed to load views",
        "saveFailed": "Save failed",
        "deleteFailed": "Delete failed"
      },
      "colsCount_one": "{{count}} col",
      "colsCount_other": "{{count}} cols",
      "filtersCount_one": "{{count}} filter",
      "filtersCount_other": "{{count}} filters",
      "column": {
        "orderNumber": "Order #",
        "product": "Product",
        "quantity": "Quantity",
        "status": "Status",
        "platform": "Platform",
        "customer": "Customer",
        "items": "Items",
        "total": "Total",
        "store": "Store",
        "created": "Created",
        "sla": "SLA",
        "actions": "Actions"
      }
    },
    "archive": {
      "_comment": "Phase 3.3 Amendment #3 — Archive custom view (bucket=archive).",
      "badge": "Archive",
      "emptyState": "No archived orders."
    },
    "settings": {
      "_comment": "Phase 6 Wave 6 Task 21 — Merchant order settings.",
      "title": "Order settings",
      "save": "Save settings",
      "saved": "Saved",
      "defaultSync": "Auto-sync orders from connected stores",
      "defaultFulfillment": {
        "label": "Default fulfilment",
        "option": {
          "manual": "Manual",
          "auto": "Auto",
          "review": "Review"
        }
      },
      "autoCancelTiming": "Auto-cancel after (minutes)",
      "defaultShippingService": "Default shipping service",
      "holdOnInventory": "Hold inventory on order create",
      "notificationEmail": "Notification email",
      "field": {
        "approvalMode": "Approval Mode",
        "threshold": "Threshold ($)",
        "enableNotifications": "Enable notifications",
        "onShipped": "On shipped",
        "onDelivered": "On delivered",
        "onExceptions": "On exceptions",
        "handlingMode": "Handling Mode",
        "delayThreshold": "Delay Threshold (days)",
        "autoEscalate": "Auto-escalate",
        "autoCancelAfter": "Auto-cancel after (minutes, 0 disables)",
        "defaultCarrier": "Default carrier",
        "cutoffTime": "Cutoff time (HH:MM)",
        "timezone": "Timezone",
        "holdInventory": "Hold inventory on order create (vs. on fulfilment)",
        "validationLevel": "Validation level",
        "autoCorrect": "Auto-correct typos when possible",
        "brandName": "Brand name (From)",
        "replyToEmail": "Reply-to email",
        "internalNotificationEmail": "Internal notification email"
      },
      "option": {
        "select": "— Select —",
        "approval": {
          "automatic": "Automatic",
          "manual": "Manual",
          "threshold": "Threshold-based"
        },
        "delay": {
          "manual": "Manual",
          "auto-escalate": "Auto-escalate",
          "auto-reassign": "Auto-reassign"
        },
        "fulfilment": {
          "manual": "Manual",
          "auto": "Automatic",
          "review": "Review-first"
        },
        "addressValidation": {
          "off": "Off (accept any input)",
          "soft": "Soft (warn on suspicious)",
          "strict": "Strict (block on invalid)"
        }
      },
      "status": {
        "enabled": "Enabled",
        "disabled": "Disabled",
        "autoSyncOn": "Auto-sync ON",
        "autoSyncOff": "Auto-sync OFF",
        "notSet": "Not set",
        "default": "Default",
        "off": "Off",
        "soft": "Soft",
        "strict": "Strict",
        "holdOnCreate": "Hold on create",
        "holdAtFulfilment": "Hold at fulfilment"
      },
      "error": {
        "loadFailed": "Failed to load settings",
        "saveFailed": "Save failed",
        "unavailable": "Settings unavailable"
      },
      "placeholder": {
        "storeName": "Your store name",
        "replyToEmail": "support@yourbrand.com",
        "notificationEmail": "ops@yourbrand.com"
      },
      "approval": {
        "label": "Approval",
        "desc": "Configure approval workflow",
        "requireManager": "Require manager approval",
        "title": "Order Approval"
      },
      "automatic": "Automatic",
      "delayedOrders": "Delayed orders",
      "disabled": "Disabled",
      "goTo": "Go to settings",
      "manual": "Manual",
      "routing": "Routing",
      "trackingNotif": "Tracking notifications",
      "addressValidation": {
        "desc": "Validate shipping addresses before fulfilment",
        "title": "Address Validation"
      },
      "cancellation": {
        "desc": "Auto-cancel unpaid orders after a timeout",
        "title": "Cancellation"
      },
      "customerComm": {
        "desc": "Email identity shown on customer-facing messages",
        "title": "Customer Communication"
      },
      "delay": {
        "desc": "Configure delay handling and escalation",
        "title": "Delayed Orders Handling"
      },
      "infobox": "These settings apply to every new order this merchant account receives.",
      "inventory": {
        "desc": "When to reserve stock for new orders",
        "title": "Inventory"
      },
      "notifications": {
        "desc": "Customer notification settings",
        "title": "Tracking Notifications"
      },
      "shipping": {
        "desc": "Default carrier + cutoff time",
        "title": "Shipping"
      },
      "subtitle": "Configure how your orders are approved, tracked, and fulfilled.",
      "sync": {
        "desc": "Auto-sync from connected stores + default fulfilment",
        "title": "Sync & Fulfilment"
      }
    },
    "resend": {
      "_comment": "Phase 6 Wave 6 Task 21 — Resend / re-trigger popup.",
      "title": "Resend order",
      "reason": "Reason",
      "submit": "Resend",
      "failed": "Resend failed"
    },
    "newBanner": {
      "one": "1 new order — click to load",
      "other": "{{count}} new orders — click to load"
    },
    "sla": {
      "green": "On track",
      "yellow": "Due soon",
      "red": "Overdue"
    },
    "columns": {
      "toggle": "Columns",
      "preset": {
        "compact": "Compact",
        "detailed": "Detailed"
      },
      "product": "Product",
      "qty": "Qty",
      "moreItems": "more",
      "order": "Order",
      "status": "Status",
      "platform": "Platform",
      "customer": "Customer",
      "items": "Items",
      "total": "Total",
      "store": "Store",
      "date": "Date",
      "sla": "SLA",
      "default": "Default",
      "email": "Email",
      "surcharge": "Surcharge",
      "orderType": "Order Type",
      "receivedTime": "Received Time",
      "approvedTime": "Approved Time",
      "late": "Late",
      "actions": "Actions"
    },
    "platform": {
      "shopify": "Shopify",
      "etsy": "Etsy",
      "manual": "Manual",
      "amazon": "Amazon",
      "tiktok": "TikTok"
    },
    "detail": {
      "_comment": "Phase 6 Wave 6 Task 18 — Order detail page copy. vg-binding: PLAN:task-18 / P6.D-44..51 / P6.D-243",
      "title": "Order detail",
      "loadError": "Failed to load order",
      "itemsTitle": "Items",
      "address": {
        "shipping": "Shipping address",
        "billing": "Billing address"
      },
      "tab": {
        "overview": "Overview",
        "activity": "Activity",
        "tracking": "Tracking"
      },
      "action": {
        "cancel": "Cancel order",
        "reorder": "Reorder",
        "refund": "Refund",
        "printPacking": "Print packing list",
        "copied": "Order ID copied to clipboard.",
        "createTicket": "Create Ticket",
        "downloadInvoice": "Download Invoice",
        "edit": "Edit",
        "editAddress": "Edit address",
        "holdQueued": "Hold request submitted to support. Our team will reach out shortly.",
        "invoicePending": "Invoice download is not yet available. Contact support if you need a copy now.",
        "more": "More actions",
        "payNow": "Pay now",
        "reportIssue": "Report Issue",
        "requestCancel": "Request Cancel",
        "requestHold": "Request Hold",
        "sendToProduction": "Send to production",
        "viewOnEtsy": "View on Etsy",
        "viewOnShopify": "View on Shopify",
        "viewOnSource": "View on source store",
        "duplicate": "Duplicate order",
        "duplicating": "Duplicating…"
      },
      "print": {
        "popupBlocked": "Popup blocked — allow popups to view the packing list."
      },
      "cost": {
        "title": "Cost breakdown",
        "products": "Products",
        "shipping": "Shipping",
        "tax": "Tax",
        "handling": "Handling",
        "surcharge": "Surcharge",
        "seasonal": "Seasonal",
        "tariff": "Tariff",
        "embroidery": "Embroidery",
        "digitizing": "Digitizing",
        "discount": "Discount",
        "total": "Total",
        "tip": {
          "products": "Sum of all line items (qty × unit price).",
          "shipping": "Per fulfilment group — multiple groups may ship separately.",
          "tax": "Sales tax / VAT — calculated by destination.",
          "handling": "Pick / pack / label fees.",
          "surcharge": "Vendor surcharges — e.g. oversized item or remote-area delivery.",
          "seasonal": "Peak-season fees (Q4 / holiday surge).",
          "tariff": "Cross-border duties / import tariffs.",
          "embroidery": "Embroidery production charge per stitch count.",
          "digitizing": "One-time fee to convert artwork to stitch file.",
          "discount": "Promotional discount — already signed."
        }
      },
      "cancel": {
        "title": "Cancel order",
        "submit": "Confirm cancel",
        "reason": {
          "label": "Reason",
          "customerRequest": "Customer request",
          "duplicate": "Duplicate",
          "outOfStock": "Out of stock",
          "paymentIssue": "Payment issue",
          "other": "Other"
        },
        "note": {
          "label": "Note (optional)"
        },
        "partial": {
          "label": "Partial cancel"
        },
        "refund": {
          "label": "Refund to Wallet Balance",
          "always": "All refunds go to Wallet — never to original method"
        }
      },
      "activity": {
        "empty": "No activity yet.",
        "actor": {
          "customer": "Customer",
          "production": "Production team",
          "system": "System",
          "merchant": "Merchant"
        },
        "showAll": "Show all {{count}}",
        "showLess": "Show less",
        "loading": "Loading activity…"
      },
      "tracking": {
        "empty": "No tracking information yet.",
        "estimatedDelivery": "Estimated delivery",
        "copyTrackingNumber": "Copy",
        "step": {
          "labelCreated": "Label created",
          "pickedUp": "Picked up",
          "inTransit": "In transit",
          "outForDelivery": "Out for delivery",
          "delivered": "Delivered"
        }
      },
      "shipping": {
        "method": {
          "merchant": "Ship by merchant",
          "tiktok": "Marketplace label"
        },
        "label": {
          "view": "View label",
          "none": "No label"
        }
      },
      "field": {
        "orderType": "Order type",
        "externalOrderId": "External Order ID",
        "manufacturingRegion": "Manufacturing Region",
        "notAssigned": "Not assigned",
        "source": "Source"
      },
      "orderType": {
        "BASIC": "Basic",
        "SAMPLE": "Sample",
        "BULK_FBA_FBT": "Bulk (FBA/FBT)",
        "BUNDLE": "Bundle"
      },
      "shippingLabelAlt": "Shipping label",
      "artwork": {
        "add": "Add artwork",
        "error": "Artwork has an issue — view",
        "errorShort": "Error",
        "pass": "Artwork OK — view"
      },
      "billing": {
        "paid": "Paid",
        "paidWithWallet": "Paid with Wallet",
        "productionCost": "Production Cost",
        "shippingCost": "Shipping Cost",
        "total": "Total",
        "transaction": "Transaction: {{ref}}",
        "unpaid": "Unpaid",
        "viewInvoice": "View Invoice"
      },
      "col": {
        "artwork": "Artwork",
        "product": "Product",
        "qty": "Qty",
        "shippingFee": "Shipping fee",
        "sku": "SKU",
        "status": "Status",
        "total": "Total",
        "unitPrice": "Unit Price"
      },
      "createdAt": "Created {{date}}",
      "fulfillment": {
        "cancelled": "Cancelled",
        "delivered": "Delivered",
        "inProgress": "In progress",
        "pending": "Pending",
        "shipped": "Shipped",
        "waiting": "Waiting to be assigned to location"
      },
      "item": {
        "addMoreMockup": "Add mockup",
        "artworkDefault": "Artwork",
        "artworks": "Artworks",
        "artworksHint": "Upload one file per print area",
        "chooseOrDrop": "Choose or drag & drop",
        "editInWizard": "Edit order",
        "formats": "Formats",
        "imagesCount": "{{count}} images",
        "loadingAreas": "Loading print areas…",
        "location": "Fulfillment",
        "lowRes": "Below 1000×1000px",
        "minDimensions": "Min. Dimensions",
        "minResolution": "Min. Resolution",
        "mockups": "Mockups",
        "mockupsHint": "Product previews",
        "noAreas": "No print areas defined for this product",
        "noAreasHint": "Artwork mapping needs the blueprint print areas configured.",
        "pricing": "Pricing",
        "productInfo": "Product Information",
        "qtyTimesPrice": "Qty × Price",
        "qualityStandards": "Printway Quality Standards",
        "required": "Required",
        "savingDots": "Saving…",
        "tab": {
          "design": "Design & Mockups",
          "details": "Details"
        },
        "uploadFailed": "Upload failed",
        "uploadForArea": "Upload {{area}} artwork",
        "uploadMockup": "Upload mockup images",
        "uploadMockupHint": "Product preview images (PNG, JPG)",
        "uploading": "Uploading…",
        "variant": "Variant",
        "openPreview": "Open preview",
        "issue": {
          "heading": "Why this item is flagged",
          "errorArtwork": "The artwork for this item failed processing. See the print area below for what to fix.",
          "onHold": "This item is on hold. Our team is reviewing it.",
          "pendingReassignment": "This item is waiting to be reassigned to a production partner. No action needed from you.",
          "attentionRequired": "This item needs attention — our team has been notified.",
          "returnedPartial": "This item was returned.",
          "partiallyCancelled": "This item was cancelled.",
          "generic": "This item is flagged for review. Our team is looking into it — no action needed from you.",
          "noAreaDetail": "No per-area detail is available for this failure — it was raised by our processing pipeline, not by your file. Contact support if it does not clear."
        }
      },
      "lineItem": {
        "artworkCount": "{{count}} artwork",
        "viewArtwork": "View artworks & mockups"
      },
      "pay": {
        "modalTitle": "Pay order {{order}}",
        "success": "Order paid from your wallet."
      },
      "refunded": {
        "label": "Refunded: {{amount}}"
      },
      "section": {
        "activity": "Activity Timeline",
        "billing": "Billing",
        "customer": "Customer",
        "fulfillment": "Fulfillment",
        "havingIssue": "Having an issue?",
        "havingIssueHint": "Report problems with production, shipping, or quality",
        "lineItems": "Line Items",
        "lineItemsHint": "Click on an item to view artworks and mockups",
        "orderInfo": "Order Info",
        "shipmentTracking": "Shipment Tracking",
        "shippingAddress": "Shipping Address",
        "status": "Order Status"
      },
      "sendToProduction": {
        "confirmBody": "Order {{order}} will be pushed to the vendor to begin production. After this step the order moves to In Production.",
        "confirmCta": "Confirm send",
        "confirmTitle": "Send this order to production?",
        "processing": "Sending…",
        "success": "Order sent to production.",
        "tooltip": "Send this order to the vendor to begin production.",
        "error": "Could not send to production."
      },
      "artworkBlocked": {
        "title": "Artwork not validated",
        "body": "These print areas need validated artwork before this order can be sent to production.",
        "areaRow": "{{item}} — {{area}}",
        "fixCta": "Go fix artwork",
        "dismiss": "Dismiss",
        "itemFallback": "Item"
      },
      "shipmentTracking": {
        "empty": "No shipment information available yet",
        "eta": "Estimated delivery"
      },
      "status": {
        "cancelled": "This order has been cancelled.",
        "errorArtwork": "This order has an artwork error — fix the flagged line item to continue.",
        "pendingReassignment": "This order is waiting to be reassigned to a production partner. No action needed from you.",
        "onHold": "This order is on hold. Our team is reviewing it.",
        "attentionRequired": "This order needs attention — please review the line items.",
        "returnedPartial": "Part of this order was returned.",
        "partiallyCancelled": "Part of this order was cancelled.",
        "issueGeneric": "This order needs attention. Our team is looking into it."
      },
      "totals": {
        "shipping": "Shipping",
        "subtotal": "Subtotal",
        "tax": "Tax",
        "total": "Total"
      },
      "editAddress": {
        "countryLocked": "Country cannot be changed.",
        "save": "Save & re-verify",
        "title": "Edit shipping address"
      },
      "duplicate": {
        "success": "Order duplicated — opening the new order…",
        "error": "Failed to duplicate the order."
      }
    },
    "payment": {
      "_comment": "Phase 6 Wave 7 Task 22 — Order payment step copy. vg-binding: PLAN:task-22 / P6.D-59 / P6.D-59c / P6.D-231 / P6.D-239 / P6.D-240 / P6.D-241 / P6.D-242 / G-37 / G-38",
      "title": "Payment",
      "method": {
        "wallet": "Wallet",
        "stripe": "Credit Card (Stripe)",
        "paypal": "PayPal",
        "credit": "Credit",
        "credit.insufficient": "Insufficient credit remaining",
        "credit.subRemaining": "Available: {{remaining}}",
        "credit.expires": "expires {{date}}",
        "wallet.subBalance": "Balance: {{balance}}",
        "insufficientBalance": "Insufficient balance — top up",
        "topupCta": "Top up",
        "teamMemberOnly": "Team members can only pay via Wallet",
        "gatewayComingSoon": "Card payments are not available yet — pay with your wallet or credit.",
        "stripe.needsCard": "No saved card — add one",
        "stripe.checking": "Checking availability…",
        "stripe.willCharge": "Charges {{card}}",
        "stripe.declined": "The card was declined — try another payment method",
        "stripe.notAllowed": "Card payment is not enabled for your account",
        "stripe.unavailable": "Could not reach the payment provider — please try again"
      },
      "payLater": {
        "label": "Pay Later",
        "help": "Creates Wallet debt — Wallet only"
      },
      "creditDebt": {
        "warning": "You owe {{credit}}. Paying with {{method}} won't reduce debt — consider Wallet.",
        "ack": "I understand"
      },
      "confirm": {
        "button": "Confirm payment",
        "processing": "Processing..."
      },
      "error": {
        "400": "Invalid request",
        "402": "Insufficient balance — top up first",
        "503": "Gateway unavailable — retry later"
      },
      "landing": {
        "verifying": "Verifying payment...",
        "timeout": "Payment is being reconciled. You'll receive a notification when complete.",
        "failed": {
          "title": "Payment failed",
          "retry": "Retry",
          "backToOrders": "Back to orders"
        },
        "success": {
          "title": "Payment successful"
        }
      },
      "paid": "Paid",
      "partial_paid": "Partially paid",
      "unpaid": "Unpaid",
      "skip": {
        "button": "Skip payment (pay later)",
        "help": "Create the order as Draft + Unpaid and pay later."
      }
    },
    "refund": {
      "_comment": "Phase 6 Wave 7 Task 23 — Refund flow copy. vg-binding: PLAN:task-23 / P6.D-46 / P6.D-243 / G-39",
      "title": "Refund order",
      "toWallet": "→ Wallet Balance",
      "disclaimer": "All refunds go to Wallet Balance. For original CC/PayPal refund, contact Admin Support.",
      "reason": {
        "label": "Refund reason",
        "defectiveProduct": "Defective product",
        "wrongItemShipped": "Wrong item shipped",
        "customerChangedMind": "Customer changed mind",
        "qualityIssue": "Quality issue",
        "shippingDamage": "Shipping damage"
      },
      "note": {
        "label": "Note (optional)"
      },
      "items": {
        "title": "Select items to refund",
        "amountLabel": "Refund amount",
        "maxOriginal": "Max: {{amount}}",
        "empty": "No refundable items."
      },
      "total": {
        "label": "Total refund"
      },
      "submit": "Confirm refund",
      "submitting": "Processing...",
      "success": "Refund successful",
      "error": "Refund failed",
      "validation": {
        "minSelect": "Select at least 1 item",
        "exceedTotal": "Refund exceeds order total",
        "generic": "Could not submit the request — check the form."
      },
      "refundAria": "Refund {{name}}"
    },
    "chargeback": {
      "_comment": "Phase 6 Wave 7 Task 23 — Chargeback display copy. vg-binding: PLAN:task-23 / P6.D-243 / G-39",
      "title": "Chargeback",
      "status": {
        "opened": "Opened",
        "evidenceRequired": "Evidence required",
        "lost": "Lost",
        "won": "Won",
        "closed": "Closed"
      },
      "openedAt": "Opened",
      "evidenceDueBy": "Evidence due by",
      "adminHandled": "Handled by Admin Support — see notes"
    },
    "badge": {
      "draft": "Draft",
      "unverified": "Unverified",
      "pending": "Pending",
      "waiting": "Waiting Approval",
      "processing": "In Production",
      "shipped": "Shipped",
      "delivered": "Completed",
      "cancelled": "Cancelled",
      "issues": "Issues",
      "paid": "Paid",
      "partialPaid": "Partial Paid",
      "embFeeDue": "Emb. Fee Due",
      "unpaid": "Unpaid",
      "refunded": "Refunded",
      "unknown": "Unknown",
      "waitingPayment": "Waiting Payment",
      "late": "Late"
    },
    "table": {
      "header": {
        "order": "Order",
        "status": "Status",
        "platform": "Platform",
        "customer": "Customer",
        "items": "Items",
        "total": "Total",
        "store": "Store",
        "created": "Created Date",
        "sla": "SLA",
        "orderType": "Order Type",
        "receivedTime": "Received Time",
        "approvedTime": "Approved Time",
        "payment": "Payment",
        "shippingName": "Shipping name",
        "seller": "Seller Name",
        "tracking": "Tracking",
        "label": "Label",
        "location": "Location",
        "embroidery": "Embroidery price",
        "surcharge": "Surcharge",
        "email": "Email",
        "late": "Late",
        "artwork": "Artwork"
      },
      "item": "item",
      "items": "items",
      "viewArtwork": "View artwork",
      "collapseItems": "Collapse items",
      "expandItems": "Expand items",
      "view": "View",
      "copyTracking": "Copy tracking number",
      "trackingMore": "+{{count}} more",
      "locationMore": "+{{count}} more",
      "artworkPerItem": "{{count}} items"
    },
    "itemStatus": {
      "draft": "Draft",
      "unverified": "Unverified",
      "pending": "Pending",
      "waiting": "Waiting Approval",
      "processing": "In Production",
      "shipped": "Shipped",
      "delivered": "Delivered",
      "cancelled": "Cancelled",
      "issues": "Issues"
    },
    "artworkDrawer": {
      "title": "Artwork",
      "loading": "Loading…",
      "itemNotFound": "Item not found.",
      "empty": "This item has no artwork template and no artwork attached yet.",
      "ingestStatus": "Artwork ingest status",
      "requirementsHeading": "Artwork requirements by print area",
      "attached": "Attached",
      "noArtwork": "No artwork",
      "requirementLabel": "Required: ",
      "noRequirement": "No template requirement for this area.",
      "actualLabel": "Actual: "
    },
    "shippingField": {
      "orderName": "Order name",
      "shippingLabel": "Shipping label",
      "recipient": "Recipient",
      "address": "Address",
      "city": "City",
      "country": "Country",
      "postalCode": "Postal code"
    },
    "artworkSpec": {
      "formatInvalid": "Format {{fmt}} is not allowed — requires {{required}}",
      "widthMismatch": "Width {{actual}}px ≠ required {{required}}px",
      "heightMismatch": "Height {{actual}}px ≠ required {{required}}px",
      "extensionInvalid": "Format {{actual}} is not allowed — requires {{required}}",
      "dimensionMismatch": "Size {{actual}}px does not match the required {{required}}px",
      "dpiTooLow": "Resolution {{actual}} DPI is below the required {{required}} DPI",
      "decodeFailed": "The image could not be read — it may be corrupt."
    },
    "wizard": {
      "step": {
        "invalidLabelLink": "Invalid link (must start with http:// or https://)",
        "uploadLabelFailed": "Label upload failed",
        "uploading": "Uploading…",
        "labelLinkPlaceholder": "https://… link to label file",
        "labelUploaded": "Label uploaded",
        "labelLinked": "Label link attached",
        "emailPlaceholder": "name@example.com",
        "orderNameRequired": "Order name is required — please enter it in the field at the top of the page (next to the title).",
        "labelRequired": "Please upload a label in the Shipping step (Marketplace label method).",
        "artworkCheckingRetry": "Checking artwork requirements — please wait a moment and try again.",
        "artworkMissing": "Required print areas still missing artwork: {{areas}}. Please go back to the Artwork step to upload.",
        "updateOrderFailed": "Failed to update order",
        "createDraftFailed": "Failed to create draft",
        "wrongSize": "wrong size",
        "uploadArtworkFailed": "Upload artwork failed — try again.",
        "addressIncomplete": "Missing shipping fields: {{fields}}",
        "variantUnresolved": "Some items have a variant that does not match the blueprint. The product may have been created with a placeholder variant — recreate it so its Size/Color come from the blueprint."
      }
    },
    "cancel": {
      "qtyAria": "{{productName}} qty to cancel"
    },
    "tracking": {
      "openAria": "Open {{carrier}} tracking in a new tab"
    },
    "bulkDiscount": {
      "cta": "Learn More"
    },
    "export": {
      "action": "Export"
    },
    "flash": {
      "paidStub": "Payment confirmed in sandbox. Order persistence wires up in a follow-up wave — your draft is not yet visible in the list below.",
      "savedDraft": "Order saved. You can pay later from the order detail page."
    },
    "edit": {
      "review": {
        "saveAndPay": "Save changes & continue to Payment",
        "saveOnly": "Save changes (pay later)"
      },
      "title": "Edit order"
    },
    "status": {
      "draft": "Draft",
      "unverified": "Unverified",
      "pending": "Pending",
      "waitingApproval": "Waiting Approval",
      "inProduction": "In Production",
      "shipped": "Shipped",
      "delivered": "Delivered",
      "cancelled": "Cancelled",
      "issues": "Issues"
    },
    "timeline": {
      "new": "New",
      "approval": "Approval",
      "production": "In Production",
      "shipped": "Shipped",
      "delivered": "Delivered"
    },
    "activity": {
      "by": "by"
    },
    "sub": {
      "artworkNone": "No artwork",
      "artworkOk": "Artwork",
      "shipping": "Ship",
      "unit": "Unit"
    },
    "checkout": {
      "cost": {
        "title": "Order cost",
        "subtitle": "Updated live from the quote",
        "subtotal": "Product subtotal",
        "discount": "Discount",
        "shipping": "Shipping",
        "seasonal": "Peak-season fee",
        "tax": "Tax",
        "tariff": "Reciprocal tariff",
        "duty": "Import duty (DDP)",
        "digitizing": "Digitizing fee",
        "rush": "Rush",
        "handling": "Handling fee",
        "embroidery": "Embroidery",
        "embroideryPending": "Pending digitize",
        "embroideryPendingTooltip": "Embroidery is priced by stitch count — finalised after digitizing.",
        "embroideryExcluded": "Excludes embroidery (pending digitize)",
        "empty": "Add products to see the cost breakdown.",
        "total": "Total",
        "confirm": "Confirm & pay",
        "confirming": "Confirming…",
        "disclaimer": "Quote is for reference only — the final price is locked at order confirmation.",
        "degradeTooltip": "Enter a shipping address to calculate zone-based fees.",
        "error": {
          "title": "Couldn't get a quote",
          "retry": "Retry"
        },
        "confirmBlocked": {
          "quoteFailed": "Cannot confirm — reprice failed. Retry the quote.",
          "priceMissing": "Remove items without a price to continue.",
          "needsAddress": "Enter a shipping address to get a final price.",
          "noPrice": "Waiting for a real price from the system."
        }
      },
      "groups": {
        "title": "Shipping groups",
        "subtitle": "Items are consolidated into packages by production location and packing class.",
        "empty": "No shipping groups yet — add products to the cart.",
        "groupName": "Group {{n}}",
        "itemCount": "{{count}} items",
        "reasonTooltip": "These items ship together — same production location and packing class.",
        "qtyLine": "Qty: {{count}}",
        "anchorBadge": "Anchor",
        "anchorTooltip": "Anchor item — charged the first-package fee for this group.",
        "accessoryBadge": "Accessory",
        "accessoryTooltip": "Bundled accessory — no extra shipping fee.",
        "serviceLabel": "Shipping service",
        "serviceOption": "{{label}} — {{price}}",
        "serviceOptionEta": "{{label}} — {{eta}} days — {{price}}",
        "degradeTooltip": "Enter a shipping address to calculate zone-based fees.",
        "rush": {
          "title": "Rush",
          "desc": "Toggling re-runs the quote.",
          "descWithFee": "Produced within 48h — extra fee applies. Toggling re-runs the quote.",
          "toggleAria": "Toggle rush production"
        }
      },
      "priceDrift": {
        "title": "Price changed",
        "desc": "Some fees changed since the quote you were viewing. Review before continuing.",
        "col": {
          "item": "Item",
          "old": "Old price",
          "new": "New price",
          "total": "Total"
        },
        "backToCart": "Back to cart",
        "accept": "Accept new price",
        "confirming": "Confirming…"
      }
    },
    "orderType": {
      "bundle": "Bundle"
    }
  },
  "stores": {
    "_comment": "Phase 6 Wave 8 Task 25 / Task 26 / Task 27 — Connect-store surface + Store detail page + cross-store sync surface (P6.D-107..114 / P6.D-202 / P6.D-112 / P6.D-223 / P6.D-237 / G-41..G-45).",
    "list": {
      "title": "My Stores",
      "subtitle": "Manage your connected e-commerce stores"
    },
    "filter": {
      "platform": {
        "label": "Platform",
        "all": "All platforms"
      },
      "status": {
        "label": "Status",
        "all": "All statuses"
      }
    },
    "view": {
      "grid": "Grid",
      "list": "List"
    },
    "connectNew": "Connect new store",
    "platform": {
      "shopify": "Shopify",
      "etsy": "Etsy",
      "amazon": "Amazon",
      "tiktok": "TikTok Shop",
      "woocommerce": "WooCommerce",
      "manual": "Manual"
    },
    "empty": {
      "title": "No stores connected",
      "subtitle": "Connect your first store to sync products and orders.",
      "cta": "Connect first store"
    },
    "kpi": {
      "activeStores": "Active Stores",
      "productsSynced": "Total Products",
      "totalOrders": "Pending Orders"
    },
    "card": {
      "productCount": "{{count}} products",
      "lastSync": "Last sync {{time}}",
      "menu": {
        "syncNow": "Sync now",
        "view": "View",
        "disconnect": "Disconnect"
      },
      "orders": "Orders",
      "products": "Products",
      "settings": "Settings",
      "sync": "Sync",
      "syncFailed": "Could not start sync",
      "syncQueued": "Sync started",
      "code": "Store code (used for bulk import)",
      "statusLabel": {
        "active": "Connected",
        "paused": "Paused",
        "disconnected": "Error",
        "pending": "Pending"
      }
    },
    "syncLogs": {
      "aggregation": {
        "title": "Sync logs",
        "filter": {
          "platform": "Platform",
          "store": "Store"
        },
        "column": {
          "store": "Store"
        },
        "allPlatforms": "All platforms",
        "allStatuses": "All statuses",
        "allStores": "All stores",
        "allTypes": "All types"
      },
      "allStores": "All stores",
      "allPlatforms": "All platforms",
      "allTypes": "All types",
      "allStatuses": "All statuses"
    },
    "externalProducts": {
      "title": "External products",
      "editMapping": "Edit mapping",
      "empty": "No external products yet.",
      "filter": {
        "all": "All",
        "mapped": "Mapped",
        "unmapped": "Unmapped",
        "review": "Review needed"
      },
      "column": {
        "title": "Title",
        "sku": "External SKU",
        "mapped": "Printway product",
        "lastSync": "Last synced"
      }
    },
    "disconnect": {
      "title": "Disconnect store",
      "banner": "You're about to disconnect store {{name}}",
      "consequences": {
        "h": "After disconnecting:"
      },
      "consequence": {
        "ordersKeep": "Existing orders kept",
        "noNewSync": "No new sync",
        "productsKept": "Imported products kept — edit manually",
        "canReconnect": "Reconnect anytime"
      },
      "reasonLabel": "Reason (optional)",
      "reasonOptional": "— Select a reason (optional) —",
      "reason": {
        "switchingPlatform": "Switching platforms",
        "closingStore": "Closing the store",
        "troubleshooting": "Troubleshooting",
        "other": "Other"
      },
      "confirmType": "Type \"disconnect\" to confirm",
      "confirmBtn": "Disconnect",
      "reconnectBtn": "Reconnect",
      "successToast": "Store disconnected.",
      "success": "Store disconnected."
    },
    "syncSettings": {
      "advanced": {
        "title": "Advanced sync settings"
      },
      "resources": {
        "h": "Sync resources"
      },
      "resource": {
        "products": "Products",
        "orders": "Orders",
        "inventory": "Inventory",
        "customers": "Customers"
      },
      "retryPolicy": "Retry policy",
      "retry": {
        "immediate": "Immediate",
        "exponential": "Exponential backoff",
        "fixed_interval": "Fixed interval"
      },
      "maxRetries": "Max retries",
      "alertEmail": "Alert email",
      "syncWindow": "Sync window",
      "windowStart": "Start",
      "windowEnd": "End",
      "windowTz": "Timezone",
      "pause": "Pause sync",
      "resume": "Resume sync"
    },
    "syncOrders": {
      "title": "Sync orders",
      "narrow": "Narrowed sync",
      "sinceDate": "Since date",
      "specificOrder": "Specific order",
      "runNarrow": "Run narrowed sync",
      "jobStatus": "Job in progress: {{jobId}}"
    },
    "syncProducts": {
      "title": "Sync products",
      "narrow": "Narrowed sync",
      "skuPrefix": "SKU prefix",
      "oosOnly": "Out-of-stock only",
      "runNarrow": "Run narrowed sync",
      "jobStatus": "Job in progress: {{jobId}}"
    },
    "status": {
      "active": "Active",
      "paused": "Paused",
      "disconnected": "Disconnected",
      "pending": "Pending"
    },
    "detail": {
      "_comment": "Phase 6 Wave 8 Task 26 — Store detail page tabs.",
      "back": "Back to stores",
      "loadError": "Could not load store details",
      "notFound": "Store not found",
      "actions": "Actions",
      "tabsAriaLabel": "Store management tabs",
      "disconnectTitle": "Disconnect store?",
      "disconnectBody": "You're about to disconnect {{name}}. All automatic syncs will stop. You can reconnect later.",
      "disconnectInProgress": "Disconnecting…",
      "tab": {
        "overview": "Overview",
        "mapping": "Mapping Center",
        "syncLogs": "Sync Logs",
        "settings": "Settings"
      },
      "action": {
        "syncProducts": "Sync products",
        "syncOrders": "Sync orders",
        "disconnect": "Disconnect"
      },
      "toast": {
        "syncProductsQueued": "Product sync queued.",
        "syncOrdersQueued": "Order sync queued.",
        "syncFailed": "Could not start sync. Please try again.",
        "disconnectFailed": "Could not disconnect store. Please try again."
      },
      "kpi": {
        "connectedSince": "Connected since",
        "totalProducts": "Total products",
        "totalOrders": "Total orders",
        "revenue30d": "Revenue (30d)",
        "lastSync": "Last sync",
        "syncStatus": "Sync status"
      },
      "health": {
        "label": "Health:",
        "healthy": "Healthy",
        "warning": "Needs attention",
        "disconnected": "Disconnected"
      },
      "recentActivity": "Recent sync activity",
      "viewAllLogs": "View all logs",
      "noActivity": "No sync activity yet.",
      "recordsCount": "{{count}} records",
      "mapping": {
        "title": "Mapping Center",
        "filterAriaLabel": "Mapping filters",
        "filter": {
          "all": "All",
          "unmapped": "Unmapped",
          "high-confidence": "High confidence (>85%)",
          "review": "Manual review"
        },
        "batchConfirm": "Batch confirm high-confidence",
        "batchConfirmDone": "Confirmed {{count}} rows.",
        "saveDone": "Mapping saved.",
        "unmappedFilter": "Unmapped",
        "highConfidence": "High confidence",
        "confidence": "Confidence",
        "noScore": "—",
        "statusReview": "Needs review",
        "statusUnmapped": "Unmapped",
        "edit": "Edit",
        "editTitle": "Edit product mapping",
        "productIdLabel": "Printway product ID",
        "productIdPlaceholder": "Enter product/variant ID…",
        "suggestionLabel": "Suggestion",
        "totalRows": "{{count}} rows",
        "empty": "No products in this filter.",
        "column": {
          "externalSku": "External SKU",
          "externalTitle": "External title",
          "mappedProduct": "Printway product",
          "confidence": "Confidence",
          "action": "Action"
        }
      },
      "syncLogs": {
        "empty": "No sync logs.",
        "retry": "Retry",
        "retryQueued": "Retry queued.",
        "pageOf": "Page {{page}} of {{total}}",
        "filter": {
          "type": "Type",
          "status": "Status",
          "from": "From",
          "to": "To",
          "allTypes": "All types",
          "allStatuses": "All statuses"
        },
        "type": {
          "products": "Products",
          "orders": "Orders",
          "inventory": "Inventory"
        },
        "status": {
          "success": "Success",
          "partial": "Partial",
          "failed": "Failed"
        },
        "column": {
          "timestamp": "Timestamp",
          "type": "Type",
          "status": "Status",
          "records": "Records",
          "duration": "Duration",
          "action": "Action"
        }
      },
      "settings": {
        "autoSyncProducts": "Auto-sync products",
        "autoSyncProductsHelp": "Automatically pull products into Printway.",
        "autoSyncOrders": "Auto-sync orders",
        "autoSyncOrdersHelp": "Automatically pull new orders into Printway.",
        "syncInterval": "Sync interval",
        "intervalOption": "{{minutes}} minutes",
        "webhookUrl": "Webhook URL",
        "webhookUrlPlaceholder": "No webhook",
        "fulfillmentPolicy": "Default fulfillment policy",
        "fulfillment": {
          "manual": "Manual",
          "auto": "Auto",
          "review": "Review required"
        },
        "inventorySync": "Inventory sync",
        "inventorySyncHelp": "Push inventory counts back to the platform.",
        "currency": "Currency",
        "save": "Save settings",
        "saving": "Saving…",
        "saveDone": "Settings saved.",
        "copyFailed": "Could not copy. Please copy manually.",
        "dangerZone": "Danger zone",
        "dangerZoneBody": "Disconnecting this store stops every automatic sync.",
        "disconnect": "Disconnect store",
        "disconnectConfirm": "Are you sure you want to disconnect this store?",
        "approvalTime": "Order approval time",
        "approvalTimeHelp": "How long to wait after an order syncs before auto-pushing it to production. Turn on Auto-sync orders to enable.",
        "approvalTimeOption": {
          "immediate": "Immediate",
          "30m": "After 30 minutes",
          "1h": "After 1 hour",
          "4h": "After 4 hours"
        }
      },
      "codeLabel": "Code",
      "rename": {
        "required": "Store name is required.",
        "success": "Store renamed.",
        "failed": "Could not rename the store.",
        "edit": "Edit store name"
      },
      "code": "Store code (used for bulk import)"
    },
    "connect": {
      "title": "Connect store",
      "subtitle": "Choose a platform to connect your store.",
      "platform": {
        "shopify": "Shopify",
        "shopifyDesc": "Connect via OAuth using your shop domain.",
        "woocommerce": "WooCommerce",
        "woocommerceDesc": "Connect with WordPress REST API keys.",
        "tiktok": "TikTok Shop",
        "tiktokDesc": "Connect TikTok Shop via OAuth.",
        "etsy": "Etsy",
        "etsyDesc": "Native OAuth coming soon — use the Chrome Extension below.",
        "amazon": "Amazon",
        "amazonDesc": "Native Amazon Seller integration coming soon.",
        "manual": "Manual store",
        "manualDesc": "Track an offline / standalone store manually.",
        "available": "Available",
        "comingSoon": "Coming soon"
      },
      "etsyExtension": "Use Etsy Chrome Extension",
      "shopify": {
        "title": "Connect Shopify",
        "subtitle": "Enter your Shopify domain to start the OAuth handshake.",
        "domainLabel": "Shopify domain",
        "connect": "Connect Shopify",
        "help": "Find this in Shopify admin → Settings → Domains. We’ll redirect you to Shopify to authorise access.",
        "helpLink": "Learn more",
        "invalidDomain": "Enter a valid Shopify domain (e.g. your-shop.myshopify.com).",
        "unknownError": "Could not start the Shopify connection. Please try again.",
        "feat": {
          "inventory": {
            "subtitle": "Real-time inventory sync across platforms",
            "title": "Inventory Management"
          },
          "orders": {
            "subtitle": "Orders flow directly to your dashboard",
            "title": "Automatic Order Sync"
          },
          "publish": {
            "subtitle": "Publish products directly to Shopify",
            "title": "Product Publishing"
          }
        },
        "redirectNote": "You'll be redirected to Shopify to authorize access to your store.",
        "urlHeading": "Enter your Shopify store URL",
        "urlHint": "Enter your myshopify.com domain"
      },
      "woo": {
        "title": "Connect WooCommerce",
        "subtitle": "Paste your WooCommerce REST API credentials.",
        "urlLabel": "Site URL",
        "keyLabel": "Consumer Key",
        "secretLabel": "Consumer Secret",
        "connect": "Connect WooCommerce",
        "helpTitle": "Where to find these",
        "help1": "WP Admin → WooCommerce → Settings → Advanced → REST API.",
        "help2": "Click “Add key”, set permissions to Read/Write, and Generate API key.",
        "help3": "Copy the Consumer Key + Consumer Secret here.",
        "invalidUrl": "Enter a valid HTTPS site URL (e.g. https://shop.example.com).",
        "missingCreds": "Consumer Key and Consumer Secret are both required.",
        "successToast": "WooCommerce store connected.",
        "unknownError": "Could not connect the WooCommerce store. Verify the credentials and try again.",
        "credsHeading": "Enter your API credentials",
        "credsHelp": "Generate a Read/Write REST API key in your WooCommerce admin and paste it here.",
        "feat": {
          "inventory": {
            "subtitle": "Real-time inventory sync across platforms",
            "title": "Inventory Management"
          },
          "orders": {
            "subtitle": "Orders flow directly to your dashboard",
            "title": "Automatic Order Sync"
          },
          "publish": {
            "subtitle": "Publish products directly to WooCommerce",
            "title": "Product Publishing"
          }
        },
        "step": {
          "creds": "API Credentials",
          "url": "Store URL",
          "verify": "Verify Connection"
        },
        "urlHeading": "Enter your store URL",
        "urlHelp": "Enter the main URL of your WooCommerce store. Make sure your store has WooCommerce installed and active.",
        "urlHint": "Enter the full URL including https://",
        "verifying": "Verifying connection…",
        "verifyingHelp": "Checking your store URL and REST API credentials."
      },
      "tiktok": {
        "title": "Connect TikTok Shop",
        "subtitle": "Authorise Printway to manage products and orders on your TikTok Shop.",
        "connect": "Connect TikTok Shop",
        "helpTitle": "How this works",
        "help1": "Click Connect to open TikTok Shop in a new window.",
        "help2": "Sign in with the seller account you want to link.",
        "help3": "Approve the requested permissions and you’ll come back here.",
        "unknownError": "Could not start the TikTok Shop connection. Please try again.",
        "access": {
          "inventory": "Inventory - Keep in sync",
          "orders": "Orders - Sync automatically",
          "products": "Products - Publish and manage"
        },
        "accessIntro": "You'll be redirected to TikTok to authorize the connection. We'll access:",
        "feat": {
          "analytics": {
            "subtitle": "Track sales performance and trends from your dashboard",
            "title": "Analytics & Insights"
          },
          "connect": {
            "subtitle": "Connect your TikTok Shop with one click using OAuth",
            "title": "Seamless Store Connection"
          },
          "orders": {
            "subtitle": "Orders flow directly to your Printway dashboard",
            "title": "Automatic Order Sync"
          },
          "publish": {
            "subtitle": "Publish your POD products directly to TikTok Shop",
            "title": "Product Publishing"
          }
        },
        "redirectNote": "You'll be redirected to TikTok to authorize the connection. Make sure you're logged into your TikTok Shop seller account.",
        "req1": "An active TikTok Shop seller account",
        "req2": "Store must be approved and in good standing",
        "req3": "Business verification completed",
        "reqTitle": "Requirements:",
        "viaTitle": "Connect via TikTok"
      },
      "callback": {
        "processing": "Processing…",
        "processingDetail": "Verifying your connection with the platform.",
        "errorTitle": "Connection failed",
        "error": "Connection failed — please retry.",
        "missingParams": "Missing OAuth parameters. Please retry the connection.",
        "invalidPlatform": "Unsupported platform in callback URL.",
        "expiredState": "Connection link expired or already used. Please retry.",
        "successToast": "Store connected successfully.",
        "backToConnect": "Back to connect"
      },
      "placeholder": {
        "shopifyDomain": "your-store.myshopify.com",
        "wooUrl": "your-store.com"
      },
      "platformDescription": {
        "shopify": "Connect your Shopify store to sync products and orders",
        "etsy": "Connect your Etsy shop to sync products and orders",
        "woocommerce": "Connect your WooCommerce store to sync products and orders",
        "tiktok": "Connect your TikTok Shop to reach millions of shoppers",
        "manual": "Create a store manually — no platform account needed"
      },
      "backToPlatforms": "Back to platforms",
      "comingSoon": "Coming Soon",
      "connect": "Connect",
      "connectedToast": "Store connected",
      "encryptedNote": "Your credentials are encrypted and stored securely",
      "etsy": {
        "extensionNote": "Native Etsy OAuth is coming soon — use the Printway Chrome Extension to import your Etsy shop today.",
        "title": "Connect Etsy"
      },
      "genericError": "Could not connect the store. Please try again.",
      "integrationGuide": "Integration Guide",
      "manual": {
        "create": "Create store",
        "feat": {
          "fulfil": {
            "subtitle": "Route manual orders through Printway production",
            "title": "Unified Fulfilment"
          },
          "track": {
            "subtitle": "Record orders from an offline / standalone store",
            "title": "Manual Order Entry"
          }
        },
        "nameLabel": "Store name",
        "namePlaceholder": "My standalone store",
        "nameRequired": "Store name is required.",
        "nameTooLong": "Store name must be at most 120 characters.",
        "subtitle": "Track an offline or standalone store by name. No platform connection required.",
        "successToast": "Manual store created.",
        "title": "Add manual store",
        "unknownError": "Could not create the store. Please try again."
      },
      "modalSubtitle": "Select a platform to connect your store:",
      "modalTitle": "Connect a Store",
      "needHelp": "Need help?",
      "newBadge": "New",
      "selected": "Selected",
      "whatYouGet": "What you'll get:",
      "connectWith": "Connect with {{name}}"
    },
    "integrationGuide": {
      "backToStores": "Back to stores",
      "title": "Integration Guide",
      "subtitle": "Author the step-by-step connection guide shown to merchants for each platform.",
      "platformTablist": "Platform",
      "emptyState": "No steps yet. Add the first step for this platform.",
      "stepTitlePlaceholder": "Step title",
      "stepBodyPlaceholder": "Step instructions…",
      "deleteStep": "Delete step",
      "addStep": "Add step",
      "autosaveNote": "Changes save automatically to this browser. Connect a backend endpoint to publish guides to all merchants."
    },
    "sync": {
      "orderNoPlaceholder": "#1234"
    },
    "connectCard": {
      "subtitle": "to start selling",
      "title": "Connect a new store"
    },
    "search": {
      "placeholder": "Search stores by name or code…",
      "label": "Search stores",
      "clear": "Clear search",
      "noResults": {
        "title": "No stores found",
        "subtitle": "Try a different search term or remove some filters."
      }
    },
    "table": {
      "col": {
        "store": "Store",
        "status": "Status",
        "products": "Products",
        "orders": "Orders",
        "lastSync": "Last sync"
      }
    },
    "settings": {
      "autoPush": {
        "label": "Auto-push mode",
        "help": "How long to wait after an order syncs before it is automatically sent to production.",
        "mode": {
          "immediate": "Immediately",
          "30m": "After 30 minutes",
          "1h": "After 1 hour",
          "4h": "After 4 hours",
          "12h": "After 12 hours",
          "24h": "After 24 hours",
          "48h": "After 48 hours",
          "custom": "Custom delay",
          "manual": "Manual (send each order myself)"
        },
        "customMinutesLabel": "Custom delay (minutes)",
        "customMinutesHelp": "Enter a delay between 1 and {{max}} minutes (up to 72 hours).",
        "customMinutesPlaceholder": "e.g. 120",
        "customMinutesSuffix": "minutes",
        "save": "Save auto-push mode",
        "saving": "Saving…",
        "success": "Auto-push settings updated.",
        "error": "Could not update auto-push settings. Please try again.",
        "errors": {
          "invalidMode": "Please choose a valid auto-push mode.",
          "customRequired": "Enter a custom delay in minutes.",
          "customBounds": "Custom delay must be between 1 and 4320 minutes (72 hours)."
        }
      }
    }
  },
  "wallet": {
    "_comment": "Phase 6 Wave 9 Task 28 — Wallet overview surface (KPI + Credit + Spending + Low-balance alert). vg-binding: PLAN:task-28 / P6.D-64 / P6.D-71..79 / G-46 / G-47",
    "overview": {
      "nav": {
        "label": "Wallet"
      },
      "title": "Wallet overview",
      "kpi": {
        "balance": "Balance",
        "creditLimit": "Credit limit",
        "creditUsed": "Credit used",
        "pendingTopups": "Pending topups",
        "monthlySpending": "Monthly spending"
      },
      "credit": {
        "title": "Credit",
        "limit": "Limit",
        "used": "Used",
        "outstanding": "Outstanding",
        "lifetimeUsed": "Total used",
        "available": "Available",
        "expiry": "Expiry",
        "expiryWarn": "Expires in {{days}} days",
        "usedHigh": "Used > 80%",
        "flow": {
          "explain": "Charge Balance first. If short, use Credit. Balance refilled → auto-repay Credit."
        },
        "blocked": {
          "limit": "Credit limit reached — cannot place orders",
          "expired": "Credit expired — cannot use"
        }
      },
      "spending": {
        "title": "Spending",
        "totalSpent": "Total spent",
        "averageDaily": "Daily average",
        "empty": "No spending data yet.",
        "range": {
          "7d": "7 days",
          "30d": "30 days",
          "90d": "90 days",
          "custom": "Custom"
        },
        "category": {
          "orderCharge": "Order charge",
          "topup": "Top up",
          "refund": "Refund",
          "creditCharge": "Credit charge",
          "creditRepay": "Credit repay",
          "sendOut": "Send out",
          "receiveIn": "Receive in",
          "cashback": "Cashback",
          "gatewayFee": "Gateway fee"
        }
      },
      "lowBalance": {
        "title": "Low balance",
        "message": "Balance {{balance}} — below {{threshold}}. Top up to avoid interruption.",
        "cta": "Top up now",
        "dismiss": "Dismiss"
      },
      "action": {
        "topup": "Top up",
        "withdraw": "Withdraw",
        "transfer": "Transfer"
      },
      "tab": {
        "overview": "Overview",
        "transactions": "Transactions",
        "linkedAccounts": "Linked accounts",
        "bankAccounts": "Bank accounts",
        "topup": "Top up",
        "withdraw": "Withdraw",
        "transactionsPlaceholder": "Transactions list lands in Task 29.",
        "linkedAccountsPlaceholder": "Linked accounts surface lands in Task 31.",
        "bankAccountsPlaceholder": "Bank accounts surface lands in Task 31.",
        "navHint": "Select a tab above to view details."
      }
    },
    "topup": {
      "_comment": "Phase 6 Wave 9 Task 29 — Wallet topup. vg-binding: PLAN:task-29 / P6.D-66 / P6.D-67 / P6.D-68 / P6.D-234 / P6.D-244 / G-48",
      "title": "Top up",
      "confirm": "Confirm",
      "type": {
        "instant": {
          "label": "Instant",
          "desc": "Funds available immediately"
        },
        "manual": {
          "label": "Manual",
          "desc": "Bank transfer + upload proof"
        }
      },
      "gateway": {
        "label": "Gateway",
        "paypal": "PayPal",
        "stripe": "Stripe",
        "payoneer": "Payoneer",
        "lianlianGlobal": "LianLian Global",
        "bankTransfer": "Bank Transfer",
        "pingpong": "Pingpong",
        "sunrate": "Sunrate",
        "worldfirst": "Worldfirst",
        "airwallex": "Airwallex"
      },
      "amount": {
        "label": "Amount",
        "invalid": "Invalid amount"
      },
      "fee": {
        "preview": "Gateway fee: {{fee}} ({{rate}}%)"
      },
      "dualMode": {
        "toggleLabel": "Mode",
        "feeCompare": "Fee Instant {{instant}}% / Manual {{manual}}%"
      },
      "manual": {
        "step": {
          "amount": "Amount",
          "invoice": "Invoice",
          "proof": "Proof"
        },
        "payee": {
          "bankName": "Bank name",
          "accountName": "Account name",
          "accountNumber": "Account number",
          "swift": "SWIFT",
          "reference": "Reference",
          "address": "Address",
          "missing": "Payee details unavailable for this gateway — contact support before transferring."
        },
        "invoice": {
          "download": "Download invoice PDF",
          "unavailable": "Pre-payment invoice PDF is not available for manual top-ups yet — transfer using the payee details above."
        },
        "proof": {
          "upload": "Upload proof",
          "uploaded": "Uploaded — awaiting review",
          "missing": "Please select a file"
        }
      },
      "history": {
        "title": "Topup history",
        "empty": "No topups yet",
        "column": {
          "createdAt": "Created at",
          "gateway": "Gateway",
          "mode": "Mode",
          "amount": "Amount",
          "status": "Status",
          "proof": "Proof",
          "action": "Action"
        },
        "status": {
          "pending": "Pending",
          "processing": "Processing",
          "completed": "Completed",
          "failed": "Failed",
          "cancelled": "Cancelled"
        },
        "action": {
          "cancel": "Cancel",
          "retry": "Retry",
          "viewProof": "View proof",
          "viewReceipt": "Receipt"
        }
      },
      "sdk": {
        "paypalPlaceholder": "PayPal Smart Buttons SDK loads here",
        "stripePlaceholder": "Stripe Elements form loads here"
      }
    },
    "transactions": {
      "_comment": "Phase 6 Wave 9 Task 30 — Wallet transactions ledger (9 types per P6.D-65 + P6.D-233 Gateway Fee). vg-binding: PLAN:task-30 / P6.D-65 / P6.D-233 / G-49",
      "tabs": {
        "transaction": "Transactions",
        "orderTransaction": "Order Transactions"
      },
      "orderTx": {
        "order": "Order",
        "txId": "Transaction ID",
        "amount": "Amount",
        "surcharge": "Surcharge",
        "kind": "Type",
        "date": "Date",
        "method": "Method",
        "note": "Note",
        "search": "Search by order code / transaction ID",
        "searchPlaceholder": "Order code or transaction ID…",
        "noMatch": "No transactions match your search",
        "empty": "No order transactions yet"
      },
      "child": {
        "type": {
          "charge": "Charge",
          "refund": "Refund",
          "surcharge": "Surcharge"
        }
      },
      "title": "Transactions",
      "subtitle": "9 transaction types — wallet ledger",
      "empty": "No transactions yet",
      "totalCount": "{{count}} transactions",
      "type": {
        "orderCharge": "Order charge",
        "topup": "Top up",
        "refund": "Refund",
        "creditCharge": "Credit charge",
        "creditRepay": "Credit repay",
        "sendOut": "Send out",
        "receiveIn": "Receive in",
        "cashback": "Cashback",
        "gatewayFee": "Gateway fee"
      },
      "column": {
        "id": "Transaction ID",
        "ts": "Time",
        "type": "Type",
        "method": "Method",
        "description": "Description",
        "note": "Note",
        "amount": "Amount",
        "balance": "Balance after",
        "action": "Action",
        "status": "Status"
      },
      "method": {
        "wallet": "Wallet",
        "credit": "Credit",
        "bank": "Bank",
        "paypal": "PayPal",
        "payoneer": "Payoneer",
        "stripe": "Stripe"
      },
      "filter": {
        "fromDate": "From",
        "toDate": "To",
        "status": "Status",
        "allTypes": "All types",
        "allStatuses": "All statuses",
        "searchId": "Transaction ID",
        "searchIdPlaceholder": "Enter transaction ID…",
        "allMethods": "All methods",
        "custom": "Custom",
        "dateRange": "Date range",
        "last30d": "Last 30 days",
        "last7d": "Last 7 days",
        "search": "Search note",
        "searchPlaceholder": "Search…",
        "today": "Today",
        "method": "Payment method"
      },
      "status": {
        "pending": "Pending",
        "completed": "Completed",
        "failed": "Failed"
      },
      "action": {
        "viewReceipt": "View receipt",
        "receiptError": "Could not download receipt"
      },
      "detail": {
        "gateway": "Gateway",
        "reference": "Reference"
      },
      "export": {
        "csv": "CSV",
        "excel": "Excel",
        "error": "Export failed"
      },
      "perPage": "Per page",
      "sort": {
        "createdAt": "Sort by date",
        "label": "Date",
        "asc": "↑",
        "desc": "↓"
      },
      "showing": "Showing {{from}}-{{to}} of {{total}}",
      "showingPage": "Showing {{from}}-{{to}}",
      "pageLabel": "Page {{page}}",
      "children": {
        "error": "Could not load order details. Please try again.",
        "empty": "No orders in this transaction."
      },
      "grouped": {
        "orderCount": "${row.orderCount} orders",
        "label_one": "Pay for 1 order",
        "label_other": "Pay for {{count}} orders",
        "orderCount_one": "{{count}} order",
        "orderCount_other": "{{count}} orders",
        "label": "Pay for {{count}} orders"
      },
      "error": "Could not load transaction history. Please try again."
    },
    "send": {
      "_comment": "Phase 6 Wave 9 Task 30 — Send Balance wizard (P6.D-69). vg-binding: PLAN:task-30 / P6.D-69 / G-49",
      "title": "Send Balance",
      "confirm": "Confirm",
      "feeFree": "Free between Printway merchants — no gateway fee.",
      "success": "Send successful",
      "recent": "Recent recipients",
      "noRecipients": "You are not in any transfer group yet. Ask an admin to add you to one.",
      "step": {
        "recipient": "Recipient",
        "confirm": "Confirm",
        "amount": "Amount",
        "verify": "Verify"
      },
      "recipient": {
        "label": "Recipient email",
        "pickLabel": "Recipient (Transfer Group members)",
        "placeholder": "Select a recipient…"
      },
      "amount": {
        "label": "Amount",
        "available": "Available: {{amount}}"
      },
      "note": {
        "label": "Note (optional)"
      },
      "error": {
        "selfSend": "Cannot send to yourself",
        "emailRequired": "Recipient email required",
        "notFound": "Recipient not found",
        "invalidAmount": "Invalid amount",
        "pickRecipient": "Please pick a recipient",
        "generic": "Send failed",
        "insufficientBalance": "Amount exceeds your available balance",
        "amountOutOfRange": "Amount is outside the transfer group limits",
        "limitExceeded": "Monthly transfer limit exceeded",
        "recipientIneligible": "Recipient is not eligible to receive transfers",
        "walletFrozen": "Your wallet is frozen — transfers are blocked"
      }
    },
    "withdraw": {
      "_comment": "Phase 6 Wave 9 Task 30 — Withdraw page + modal. vg-binding: PLAN:task-30 / G-50",
      "title": "Withdraw",
      "subtitle": "Request a payout from your wallet to a bank account",
      "bankAccount": "Bank account",
      "amount": "Amount",
      "feePreview": "Fee",
      "netAmount": "Net amount",
      "estimatedArrival": "Estimated arrival",
      "confirm": "Confirm withdrawal",
      "request": "Request withdrawal",
      "availableBalance": "Available balance",
      "empty": "No verified bank accounts. Add one in Settings.",
      "success": "Withdrawal submitted",
      "successWithEta": "Withdrawal submitted — estimated arrival {{eta}}",
      "error": {
        "exceedsBalance": "Amount exceeds available balance",
        "noAccount": "Select a bank account",
        "generic": "Withdrawal failed"
      }
    },
    "transfer": {
      "_comment": "Phase 6 Wave 9 Task 30 — Transfer modal between own linked accounts. vg-binding: PLAN:task-30 / G-50",
      "title": "Transfer",
      "from": "From",
      "to": "To",
      "amount": "Amount",
      "confirm": "Confirm transfer",
      "selectAccount": "Select account",
      "error": {
        "required": "Choose source and destination accounts",
        "sameAccount": "Source and destination must differ",
        "invalidAmount": "Invalid amount",
        "generic": "Transfer failed"
      }
    },
    "twoFA": {
      "_comment": "Phase 6 Wave 9 Task 30 — 2FA challenge re-used by Send + Withdraw + Transfer. vg-binding: PLAN:task-30 / P6.D-69",
      "title": "2FA verify",
      "code": "6-digit code",
      "verify": "Verify",
      "error": "Invalid code"
    },
    "linkedAccounts": {
      "_comment": "Phase 6 Wave 9 Task 31 — Linked accounts management (Send Balance quick-list). vg-binding: PLAN:task-31 / P6.D-69 / G-51",
      "title": "Linked accounts",
      "subtitle": "Quick-list of Printway merchants you can send balance to.",
      "add": "Add linked",
      "empty": "No linked accounts",
      "deleteConfirm": "Remove link with {{email}}?",
      "deleteSuccess": "Linked account removed",
      "deleteError": "Failed to remove linked account",
      "addSuccess": "Linked account added",
      "modal": {
        "email": "Recipient email",
        "lookup": {
          "match": "Found: {{name}}",
          "notFound": "User not found"
        },
        "errorEmailRequired": "Recipient email required",
        "errorSelfLink": "Cannot self-link",
        "errorGeneric": "Failed to link account",
        "add": "Add"
      }
    },
    "bankAccounts": {
      "_comment": "Phase 6 Wave 9 Task 31 — Bank accounts management for withdrawals. vg-binding: PLAN:task-31 / P6.D-69 / G-51",
      "title": "Bank accounts",
      "subtitle": "Verified bank accounts available for withdrawal.",
      "add": "Add account",
      "empty": "No bank accounts",
      "verified": "Verified",
      "notVerified": "Not verified",
      "deleteConfirm": "Delete this account?",
      "deleteSuccess": "Bank account removed",
      "deleteError": "Failed to remove bank account",
      "addSuccessWithMask": "Added bank account {{mask}}",
      "field": {
        "bankName": "Bank name",
        "accountName": "Account name",
        "accountNumber": "Account number",
        "accountType": "Account type",
        "routingNumber": "Routing number",
        "country": "Country",
        "swift": "SWIFT / BIC",
        "iban": "IBAN",
        "address": "Merchant address",
        "addressStreet": "Street address",
        "addressCity": "City",
        "addressState": "State / Province",
        "addressZip": "ZIP / Postal code"
      },
      "accountType": {
        "checking": "Checking",
        "savings": "Savings"
      },
      "country": {
        "US": "United States",
        "VN": "Vietnam",
        "GB": "United Kingdom",
        "FR": "France",
        "DE": "Germany",
        "CN": "China",
        "JP": "Japan",
        "AU": "Australia",
        "CA": "Canada",
        "SG": "Singapore"
      },
      "modal": {
        "step": {
          "form": "Details",
          "twoFA": "2FA verify"
        },
        "errorRequired": "Please fill all required fields",
        "errorGeneric": "Failed to add bank account",
        "add": "Add account"
      }
    },
    "pageTab": {
      "aria": "Wallet sections",
      "overview": "Overview",
      "billing": "Billing",
      "invoices": "Invoices",
      "transactions": "Transactions",
      "paymentMethods": "Payment Methods",
      "billingSettings": "Billing Settings",
      "paymentRequests": "Payment Requests"
    },
    "recent": {
      "cancelError": "Could not cancel — please try again.",
      "title": "Recent transactions",
      "viewAll": "View all →",
      "loading": "Loading…",
      "empty": "No transactions yet. Create a topup or withdraw to get started.",
      "cancel": "Cancel",
      "col": {
        "description": "Description",
        "date": "Date",
        "amount": "Amount",
        "balanceAfter": "Balance after",
        "method": "Payment method"
      },
      "pending": "Pending approval"
    },
    "tx": {
      "orderCharge": "Payment for {{count}} orders",
      "orderRefund": "Refund for {{count}} orders",
      "transferIn": "Received from merchant",
      "transferOut": "Sent to merchant"
    }
  },
  "billing": {
    "_comment": "Phase 6 Wave 10 Task 32 — Billing standalone Finance entry. vg-binding: PLAN:task-32 / P6.D-01 / P6.D-245 / P6.D-247",
    "nav": {
      "label": "Billing"
    },
    "overview": {
      "title": "Billing overview",
      "kpi": {
        "outstanding": "Outstanding",
        "dueSoon": "Due soon",
        "overdue": "Overdue"
      },
      "link": {
        "invoices": "Invoices",
        "addresses": "Billing addresses",
        "paymentHistory": "Payment history",
        "statements": "Statements",
        "paymentMethods": "Payment methods"
      },
      "cta": {
        "create": "Create invoice"
      },
      "mode": {
        "prepaid": {
          "subtext": "Prepaid mode — invoices are reports only."
        },
        "credit": {
          "subtext": "Credit mode — invoices are reports only."
        },
        "invoice": {
          "subtext": "Invoice mode — pay on time to avoid overdue."
        }
      },
      "preview": {
        "viewAll": "View all →",
        "empty": "No records yet.",
        "statementSub": "Charges {{charges}} · Payments {{payments}}",
        "default": "Default"
      }
    },
    "list": {
      "title": "Invoices",
      "column": {
        "invoiceNumber": "Invoice #",
        "status": "Status",
        "issueDate": "Issue date",
        "dueDate": "Due date",
        "amount": "Amount",
        "actions": "Actions"
      },
      "filter": {
        "status": "Status",
        "all": "All",
        "draft": "Draft",
        "pending": "Pending",
        "paid": "Paid",
        "overdue": "Overdue",
        "cancelled": "Cancelled",
        "dateRange": "Billing period",
        "dateRangeHint": "Filters by the period an invoice covers, not its issue date.",
        "dateRangePlaceholder": "Start date – End date"
      },
      "action": {
        "view": "View",
        "pay": "Pay"
      },
      "empty": "No invoices yet"
    },
    "status": {
      "draft": "Draft",
      "pending": "Pending",
      "paid": "Paid",
      "overdue": "Overdue",
      "cancelled": "Cancelled",
      "dueSoon": "Due soon"
    },
    "create": {
      "_comment": "Phase 6 Wave 10 Task 33 — Invoice CREATE page. vg-binding: PLAN:task-33 / P6.D-245",
      "title": "Create invoice",
      "field": {
        "customer": {
          "label": "Customer",
          "placeholder": "Customer name"
        },
        "issueDate": "Issue date",
        "dueDate": "Due date",
        "lineItem": {
          "description": "Description",
          "qty": "Qty",
          "unitPrice": "Unit price",
          "lineTotal": "Line total"
        },
        "notes": "Notes",
        "terms": "Terms",
        "taxRate": "Tax rate (%)",
        "email": "Email"
      },
      "terms": {
        "net7": "Net 7",
        "net15": "Net 15",
        "net30": "Net 30",
        "net60": "Net 60",
        "custom": "Custom",
        "customPlaceholder": "Custom terms"
      },
      "lineItems": {
        "add": "Add line"
      },
      "section": {
        "lineItems": "Line items"
      },
      "subtotal": "Subtotal",
      "creditApplied": "Credit applied",
      "tax": "Tax",
      "total": "Total",
      "submit": "Create",
      "submitting": "Creating...",
      "error": {
        "noLineItems": "Add at least one line item",
        "generic": "Failed to create invoice"
      }
    },
    "detail": {
      "_comment": "Phase 6 Wave 10 Task 33 — Invoice DETAIL page. vg-binding: PLAN:task-33 / P6.D-245",
      "title": "Invoice detail",
      "empty": "Invoice not found",
      "action": {
        "pay": "Pay",
        "downloadPdf": {
          "label": "Download PDF",
          "loading": "Downloading..."
        },
        "downloadPdfLoading": "Downloading...",
        "viewCustomer": "View customer",
        "dispute": {
          "label": "Dispute this invoice",
          "loading": "Opening dispute..."
        }
      },
      "section": {
        "customer": "Customer",
        "dates": "Issued / Due",
        "lineItems": "Line items",
        "totals": "Totals",
        "notes": "Notes",
        "payments": "Payment history"
      },
      "lineItems": {
        "empty": "No line items"
      },
      "payments": {
        "empty": "No payments yet"
      },
      "pdf": {
        "notReadyTitle": "PDF not ready",
        "notReady": "The invoice PDF is still being generated. Try again shortly."
      },
      "dispute": {
        "subject": "Invoice dispute: #{{invoiceNumber}}",
        "body": "Merchant raised a dispute for invoice #{{invoiceNumber}}. Please review the charges and respond.",
        "errorTitle": "Could not open dispute",
        "error": "Failed to create the dispute ticket. Please try again."
      }
    },
    "pay": {
      "_comment": "Phase 6 Wave 10 Task 33 — Invoice PAYMENT page. vg-binding: PLAN:task-33 / P6.D-241 / P6.D-245",
      "title": "Pay invoice",
      "summary": "Invoice #{{number}} — Total {{amount}}",
      "confirm": "Confirm payment",
      "processing": "Processing...",
      "success": "Payment successful",
      "error": "Payment failed",
      "alreadyPaid": "This invoice is already paid — nothing more was charged. If your bank shows a pending hold, it will drop off on its own.",
      "changed": "This invoice changed while you were paying — nothing was charged. Review it and try again."
    },
    "paymentHistory": {
      "_comment": "Phase 6 Wave 10 Task 33 — Payment history page. vg-binding: PLAN:task-33 / P6.D-245",
      "title": "Payment history",
      "empty": "No payments yet",
      "filter": {
        "from": "From",
        "to": "To",
        "method": {
          "label": "Method",
          "all": "All",
          "wallet": "Wallet",
          "stripe": "Stripe",
          "paypal": "PayPal",
          "bankTransfer": "Bank transfer"
        }
      },
      "column": {
        "ts": "Timestamp",
        "invoice": "Invoice",
        "method": "Method",
        "amount": "Amount",
        "status": "Status",
        "reference": "Reference",
        "action": "Action"
      },
      "status": {
        "success": "Success",
        "pending": "Pending",
        "failed": "Failed"
      },
      "action": {
        "viewReceipt": "View receipt"
      }
    },
    "statements": {
      "_comment": "Phase 6 Wave 10 Task 33 — Statements page. vg-binding: PLAN:task-33 / P6.D-70",
      "title": "Statements",
      "empty": "No statements for this period",
      "period": {
        "label": "Period",
        "daily": "Daily",
        "weekly": "Weekly",
        "monthly": "Monthly",
        "custom": "Custom"
      },
      "column": {
        "periodStart": "Period start",
        "periodEnd": "Period end",
        "totalCharges": "Charges",
        "totalPayments": "Payments",
        "balance": "Balance",
        "breakdown": "Breakdown by category"
      },
      "chart": {
        "title": "Charges vs payments"
      },
      "legend": {
        "charges": "Charges",
        "payments": "Payments"
      },
      "table": {
        "title": "Statements"
      },
      "download": "Download statement",
      "noData": "No data yet.",
      "breakdownEmpty": "No category spending in this period"
    },
    "paymentMethods": {
      "_comment": "Phase 6 Wave 10 Task 34 — Payment methods management. vg-binding: PLAN:task-34 / P6.D-66 / G-56",
      "title": "Payment methods",
      "add": "Add method",
      "empty": "No saved methods",
      "default": "Default",
      "setDefault": "Set default",
      "deleteConfirm": "Delete this method?",
      "last4": "•••• {{last4}}",
      "expiry": "Expires {{month}}/{{year}}",
      "addSuccess": "Method added",
      "deleteSuccess": "Method deleted",
      "deleteError": "Delete failed",
      "setDefaultSuccess": "Default updated",
      "setDefaultError": "Could not update default",
      "brand": {
        "visa": "Visa",
        "mastercard": "Mastercard",
        "amex": "Amex",
        "paypal": "PayPal",
        "card": "Card"
      },
      "modal": {
        "subtitle": "Pick a provider and enter details",
        "tabsLabel": "Provider",
        "tabs": {
          "stripe": "Credit card (Stripe)",
          "paypal": "PayPal"
        },
        "cardNumber": "Card number",
        "expDate": "Expiration",
        "cvc": "CVC",
        "holderName": "Cardholder name",
        "billingZip": "Billing ZIP",
        "save": "Save",
        "connectPaypal": "Connect PayPal",
        "setDefault": "Set as default",
        "paypalSubtitle": "Connect your PayPal account through OAuth to pay invoices.",
        "error": {
          "required": "Please fill in all card details",
          "generic": "Could not add payment method",
          "cardDeclined": "Your card was declined. Please try a different card.",
          "insufficientFunds": "Your card has insufficient funds.",
          "incorrectCvc": "Your card's security code is incorrect.",
          "expiredCard": "Your card has expired.",
          "processingError": "An error occurred while processing your card. Please try again.",
          "incompleteCard": "Please complete all card details.",
          "authFailed": "Card authentication failed. Please try again.",
          "notConfigured": "Card payments are not enabled for this platform.",
          "network": "Could not reach the payment provider. Please try again.",
          "duplicate": "This card has already been added."
        },
        "cardLoading": "Loading secure card form…",
        "cardUnavailable": "Card payments are not available right now. Please contact support or use PayPal.",
        "terms": "Your card is stored securely by Stripe and will be used for future invoice payments. You can remove it at any time."
      }
    },
    "fulfillmentReports": {
      "_comment": "Phase 6 Wave 10 Task 34 — Fulfillment reports list + generate. vg-binding: PLAN:task-34 / P6.D-66 / G-56",
      "title": "Fulfillment reports",
      "generate": "Generate new report",
      "empty": "No reports yet",
      "column": {
        "period": "Period",
        "totalOrders": "Orders fulfilled",
        "totalRevenue": "Revenue",
        "status": "Status",
        "generatedAt": "Generated",
        "download": "Download"
      },
      "status": {
        "generating": "Generating",
        "ready": "Ready",
        "failed": "Failed"
      },
      "download": {
        "pdf": "PDF",
        "csv": "CSV"
      },
      "generate.title": "Generate fulfillment report",
      "generate.period.label": "Period",
      "generate.period.last7d": "Last 7 days",
      "generate.period.last30d": "Last 30 days",
      "generate.period.last90d": "Last 90 days",
      "generate.period.custom": "Custom range",
      "generate.storeFilter": "Filter by store (comma-separated ids)",
      "generate.categoryFilter": "Filter by product category (comma-separated ids)",
      "generate.submit": "Generate",
      "generate.processing": "Generating... ({{pct}}%)",
      "generate.error.dateRequired": "Pick both from and to dates",
      "generate.error.generic": "Could not generate report"
    }
  },
  "settings": {
    "_comment": "Phase 6 Wave 11 Task 35 — Settings surface (Profile + General + Activity timeline). vg-binding: PLAN:task-35 / P6.D-122 / P6.D-123 / P6.D-131 / P6.D-132 / P6.D-221 / P6.D-249 / G-57 / G-69",
    "nav": {
      "label": "Settings"
    },
    "savedAt": "Saved at {{ts}}",
    "tab": {
      "profile": "Profile",
      "security": "Security",
      "notifications": "Notifications",
      "preferences": "Preferences",
      "activity": "Activity",
      "general": "General",
      "team": "Team",
      "branding": "Branding",
      "apiKeys": "API Keys",
      "connections": "Connections",
      "security.placeholder": "Security settings — coming soon.",
      "notifications.placeholder": "Notification settings — coming soon.",
      "preferences.placeholder": "Preference settings — coming soon."
    },
    "profile": {
      "title": "Profile",
      "avatar": "Upload avatar",
      "name": "Name",
      "email": "Email",
      "email.readonly": "Contact Support to change your email.",
      "phone": "Phone",
      "timezone": "Timezone",
      "language": "Language",
      "save": "Save",
      "address": {
        "address": "Address",
        "city": "City/District",
        "country": "Country",
        "countryPlaceholder": "Select a country",
        "helper": "This address will be used for invoices and payment requests, and related documents.",
        "state": "State/Province",
        "statePlaceholder": "Select a state/province",
        "title": "Address Information",
        "zip": "Zip Code",
        "fieldAddress": "Address",
        "fieldCity": "City",
        "fieldZip": "Zip code",
        "fieldCountry": "Country",
        "incomplete": "To save your address, please also fill: {{fields}}."
      },
      "dob": "Date of Birth",
      "fullName": "Full name",
      "gender": {
        "label": "Gender",
        "female": "Female",
        "male": "Male",
        "other": "Other",
        "preferNot": "Prefer not to say"
      },
      "phoneDial": "Country code",
      "saveChanges": "Save Changes"
    },
    "general": {
      "title": "General settings",
      "billingInfo": "Billing info",
      "billingInfo.subtitle": "Used on invoices, receipts and tax documentation.",
      "billingInfo.legalName": "Legal name",
      "billingInfo.taxId": "Tax ID",
      "billingInfo.addressLine1": "Address line 1",
      "billingInfo.addressLine2": "Address line 2",
      "billingInfo.city": "City",
      "billingInfo.state": "State / Province",
      "billingInfo.postalCode": "Postal code",
      "billingInfo.country": "Country",
      "billingMode": "Billing mode",
      "billingMode.adminControlled": "Billing mode is set by Admin Support. Contact us to request a change.",
      "billingMode.prepaid.label": "Prepaid",
      "billingMode.prepaid.explain": "Prepaid wallet, no invoices payable",
      "billingMode.credit.label": "Credit",
      "billingMode.credit.explain": "Charge against credit limit",
      "billingMode.invoice.label": "Invoice",
      "billingMode.invoice.explain": "Pay invoices on schedule",
      "preferences": "Preferences",
      "preferences.subtitle": "Theme, density and display language."
    },
    "preferences": {
      "theme": "Theme",
      "theme.light": "Light",
      "theme.dark": "Dark",
      "theme.system": "System",
      "density": "Density",
      "density.compact": "Compact",
      "density.normal": "Normal",
      "currency": {
        "usd": "US Dollar",
        "vnd": "Vietnamese Dong",
        "eur": "Euro",
        "gbp": "British Pound",
        "aud": "Australian Dollar",
        "cad": "Canadian Dollar",
        "jpy": "Japanese Yen",
        "cny": "Chinese Yuan"
      }
    },
    "activity": {
      "title": "Recent activity",
      "empty": "No recent activity.",
      "ipPrefix": "IP:",
      "loadMore": "Load more activity",
      "subtitle": "Recent activities and login history for your account"
    },
    "security": {
      "_comment": "Phase 6 Wave 11 Task 36 — Security (Password + 2FA + Sessions + Login history). vg-binding: PLAN:task-36 / P6.D-124..130 / G-58 / G-59",
      "title": "Security",
      "openLink": "Open",
      "forgotPassword": "Forgot your password?",
      "devices": {
        "title": "Devices and history"
      },
      "password": {
        "change": "Change password",
        "current": "Current password",
        "new": "New password",
        "confirm": "Confirm new password",
        "submit": "Update password",
        "tooShort": "Minimum 8 characters.",
        "mismatch": "Passwords do not match.",
        "changedRedirect": "Password updated. Redirecting to login…",
        "strength": {
          "weak": "Weak",
          "medium": "Medium",
          "strong": "Strong"
        },
        "show": "Show password",
        "hide": "Hide password",
        "currentWrong": "Current password is incorrect.",
        "sameAsCurrent": "New password must be different from the current password.",
        "matched": "Passwords match.",
        "success": "Password changed successfully. Your other sessions were signed out.",
        "title": "Change Password"
      },
      "2fa": {
        "label": "Two-factor authentication",
        "subtitle": "Add a second factor (authenticator app) to protect sign-ins and high-value actions.",
        "enabled": "Enabled",
        "disabled": "Disabled",
        "setup": "Set up 2FA",
        "disable": "Disable 2FA",
        "disableConfirm": "Enter your account password to disable two-factor authentication.",
        "scanQr": "Scan the QR with your authenticator app",
        "qrAlt": "2FA enrollment QR code",
        "manualKey": "Or enter this key manually",
        "codeLabel": "6-digit authenticator code",
        "verify": "Verify and enable",
        "enabledSuccess": "Two-factor authentication is now enabled on your account.",
        "recoveryCodes": {
          "title": "Recovery codes",
          "warn": "Save these codes now — they are shown only once. Each code can be used once if you lose access to your authenticator app.",
          "download": "Download as TXT",
          "unavailable": "No recovery codes were issued. Contact Support if you need new codes.",
          "savedAck": "I have saved these codes"
        },
        "qrUnavailable": "QR unavailable",
        "codePlaceholder": "Enter 6-digit code from your app",
        "enable": "Enable 2FA",
        "manualCode": "Manual entry code:",
        "setupHint": "Scan this QR code with any authenticator app (Google Authenticator, Authy, Microsoft Authenticator, etc.)",
        "setupTitle": "Setup Two-Factor Authentication",
        "tagline": "Add an extra layer of security to your account",
        "verifyEnable": "Verify & Enable",
        "codeHint": "The code changes every 30 seconds. Enter the code shown in Google Authenticator right when you click Verify (don't use an old code).",
        "passwordLabel": "Account password",
        "passwordTooShort": "Enter your account password (at least 8 characters)."
      }
    },
    "sessions": {
      "_comment": "Phase 6 Wave 11 Task 36 — Active sessions. vg-binding: PLAN:task-36 / P6.D-126 / G-58",
      "title": "Active sessions",
      "subtitle": "Devices currently signed into your account. Revoke any session you do not recognize.",
      "current": "Current",
      "revoke": "Revoke",
      "revokeAll": "Revoke all other sessions",
      "revokeAllConfirm": "Sign out from every other device? Your current session is kept.",
      "empty": "No active sessions.",
      "column": {
        "device": "Device",
        "ip": "IP address",
        "location": "Location",
        "lastActive": "Last active"
      },
      "activeNow": "Active now",
      "signOut": "Sign out",
      "signOutAll": "Sign out all other sessions"
    },
    "loginHistory": {
      "_comment": "Phase 6 Wave 11 Task 36 — Login history. vg-binding: PLAN:task-36 / P6.D-127 / G-58 / G-59",
      "title": "Login history",
      "subtitle": "Recent successful and failed login attempts on your account.",
      "empty": "No login attempts in this range.",
      "filter": {
        "from": "From",
        "to": "To"
      },
      "column": {
        "ts": "Timestamp",
        "ip": "IP address",
        "location": "Location",
        "device": "Device",
        "browser": "Browser",
        "status": "Status",
        "reason": "Reason"
      },
      "status": {
        "all": "All",
        "success": "Success",
        "failed": "Failed"
      }
    },
    "impersonate": {
      "_comment": "Phase 6 Wave 11 Task 36 — Admin impersonation banner. vg-binding: PLAN:task-36 / P6.D-128 / P6.D-130",
      "banner": "You are viewing as {{merchant}} (Admin {{admin}})",
      "stop": "Stop impersonating"
    },
    "team": {
      "_comment": "Phase 6 Wave 11 Task 37 — Team Members + suspend/deactivate/reactivate + budget config. vg-binding: PLAN:task-37 / P6.D-80..D-91 / G-60 / G-61",
      "title": "Team members",
      "subtitle": "Invite teammates and control what they can see and spend.",
      "create": {
        "label": "Invite team member",
        "description": "Create a pending team invitation with role and spending limits."
      },
      "empty": "No team members yet.",
      "search": {
        "label": "Search",
        "placeholder": "Search by name or email…"
      },
      "filter": {
        "allRoles": "All roles",
        "allStatus": "All statuses"
      },
      "footer": {
        "count": "{{count}} member(s)"
      },
      "tab": {
        "profile": "Profile",
        "permissions": "Permissions",
        "budget": "Budget",
        "activity": "Activity"
      },
      "role": {
        "admin": "Admin",
        "admin.desc": "Full access — billing, team, every setting.",
        "manager": "Manager",
        "manager.desc": "Operations + finance, no team or billing settings.",
        "staff": "Staff",
        "staff.desc": "Day-to-day order + product work, limited finance.",
        "viewer": "Viewer",
        "viewer.desc": "Read-only — dashboards, orders and reports."
      },
      "status": {
        "active": "Active",
        "suspended": "Suspended",
        "deactivated": "Deactivated",
        "pending": "Pending invite"
      },
      "column": {
        "avatar": "Avatar",
        "name": "Member",
        "email": "Email",
        "role": "Role",
        "status": "Status",
        "lastLogin": "Last login",
        "budget": "Budget",
        "orderLimit": "Order limit",
        "actions": "Actions"
      },
      "form": {
        "field": {
          "name": "Name",
          "email": "Email",
          "role": "Role",
          "monthlyBudget": "Monthly budget (USD)",
          "orderLimit": "Per-order limit (USD)",
          "sendInvite": "Send activation email now"
        },
        "budget": {
          "help": "Member's monthly spending cap (USD). Empty = unlimited."
        }
      },
      "action": {
        "suspend": {
          "title": "Suspend account",
          "warn": "User cannot log in while suspended. Reversible.",
          "description": "Confirm a reversible suspension and capture the audit reason."
        },
        "deactivate": {
          "title": "Deactivate permanently",
          "warn": "This CANNOT be undone. All sessions revoked.",
          "typeConfirm": "Type 'deactivate' to confirm",
          "description": "Confirm irreversible deactivation, audit reason, and session revocation."
        },
        "reactivate": "Reactivate",
        "resendInvite": "Resend invite"
      },
      "reason": {
        "label": "Reason (required)"
      },
      "activity": {
        "placeholder": "Per-member activity log lands in a later wave. See Settings → Activity for the account-wide timeline."
      },
      "create.success": "Invite sent to {{email}}.",
      "update.success": "Member updated.",
      "suspend.success": "Member suspended.",
      "deactivate.success": "Member deactivated.",
      "reactivate.success": "Member reactivated.",
      "resendInvite.success": "Invitation re-sent.",
      "detail": {
        "description": "Edit team member profile, role, spending limits, and activity details."
      }
    },
    "notifications": {
      "toggleAria": "{{cat}} {{ch}}"
    },
    "account": {
      "subtitle": "Manage your profile, security, notifications, and preferences",
      "title": "Account Settings"
    },
    "pref": {
      "appearance": "Appearance",
      "communication": {
        "label": "Communication Settings",
        "sub": "How and when we email you."
      },
      "currency": "Currency",
      "dashboardView": {
        "label": "Default Dashboard View",
        "compact": "Compact",
        "expanded": "Expanded (More details)",
        "help": "How data tables display by default"
      },
      "dateFormat": "Date Format",
      "display": {
        "label": "Display Settings",
        "sub": "Appearance and default dashboard layout."
      },
      "emailDigest": {
        "label": "Email Digest",
        "daily": "Daily",
        "help": "Summary of activity sent to your email",
        "monthly": "Monthly",
        "none": "None",
        "weekly": "Weekly Summary"
      },
      "regional": {
        "label": "Regional Settings",
        "sub": "Currency and date format used across the app."
      },
      "save": "Save Changes"
    }
  },
  "branding": {
    "_comment": "Phase 6 Wave 11 Task 38 — Branding settings (4 tabs) + changelog. vg-binding: PLAN:task-38 / P6.D-100 / P6.D-101 / P6.D-105 / G-62 | Task 39 — gift-messages + thank-you-cards (P6.D-102 / P6.D-103 / G-64)",
    "title": "Branding",
    "openEditor": "Open full editor",
    "tab": {
      "brandIdentity": "Brand identity",
      "thankYouCards": "Thank-you cards",
      "thankYouCards.description": "Design the printed thank-you card customers find inside their order. Full editor lives on the dedicated Thank-you cards page.",
      "giftMessages": "Gift messages",
      "giftMessages.description": "Manage gift-message templates merchants and customers can apply at checkout. Full editor lives on the dedicated Gift messages page.",
      "packaging": "Packaging"
    },
    "identity": {
      "title": "Brand identity",
      "subtitle": "Logo, colours and tagline shown across receipts, invoices and packaging.",
      "brandName": "Brand name",
      "logo": "Logo",
      "uploadLogo": "Upload logo",
      "primaryColor": "Primary colour",
      "secondaryColor": "Secondary colour",
      "fontFamily": "Font family",
      "tagline": "Tagline",
      "taglinePlaceholder": "Short slogan for receipts and packaging",
      "save": "Save",
      "preview": "Preview",
      "previewBadge": "Sample badge"
    },
    "packaging": {
      "title": "Default packaging",
      "description": "Pick the packaging insert applied to every order by default. Admin curates the catalog.",
      "defaultLabel": "Default",
      "setDefault": "Set as default",
      "empty": "No packaging categories available yet."
    },
    "changelog": {
      "title": "Recent branding changes",
      "empty": "No branding changes yet.",
      "entry": "{{actor}} updated {{field}} from {{oldValue}} to {{newValue}}"
    },
    "giftMessages": {
      "title": "Gift messages",
      "create": "Create new",
      "submit": "Save gift message",
      "preview": "Preview",
      "previewPlaceholder": "Your message will appear here.",
      "savedToast": "Gift message saved.",
      "empty": "No gift-message templates yet. Create one to offer it at checkout.",
      "field": {
        "title": "Title",
        "occasion": "Occasion",
        "message": "Message",
        "language": "Language",
        "isDefault": "Default",
        "charCounter": "{{count}} / {{max}}"
      },
      "occasion": {
        "birthday": "Birthday",
        "holiday": "Holiday",
        "anniversary": "Anniversary",
        "thankYou": "Thank you",
        "custom": "Custom"
      },
      "backToSettings": "Back to Branding settings",
      "edit": "Edit gift message",
      "editNotFound": "Gift message not found.",
      "noResults": "No gift messages match your search.",
      "resultsCount": "{{count}} results",
      "searchPlaceholder": "Search gift messages…"
    },
    "thankYouCards": {
      "title": "Thank-you cards",
      "create": "Create new",
      "submit": "Save card",
      "preview": "Live preview",
      "previewPlaceholder": "Your message appears here.",
      "savedToast": "Thank-you card saved.",
      "empty": "No thank-you cards yet. Create one or pick a template below.",
      "imageHint": "PNG / JPG, ≤ 5 MB",
      "field": {
        "title": "Title",
        "header": "Header line",
        "body": "Body",
        "footer": "Footer line",
        "fontFamily": "Font",
        "accentColor": "Accent colour",
        "image": "Image (optional)",
        "isDefault": "Default"
      },
      "templates": {
        "title": "Start from a template",
        "useThis": "Use this template",
        "empty": "No templates available yet.",
        "prefilled": "Prefilled from template."
      },
      "backToSettings": "Back to Branding settings",
      "edit": "Edit thank-you card",
      "editNotFound": "Thank-you card not found.",
      "imageTooLarge": "Image must be 8 MB or smaller.",
      "noResults": "No cards match your search.",
      "resultsCount": "{{count}} results",
      "searchPlaceholder": "Search cards…"
    },
    "logoAlt": {
      "logo": "Brand logo",
      "preview": "Brand logo preview"
    }
  },
  "notifications": {
    "_comment": "Phase 6 Wave 11 Task 38 — Notification preferences (7 categories × 3 channels + sound). Phase 6 Wave 12 Task 40 — extended with Notification Center labels (6 tabs / grouped list / empty state / settings sibling / WS-live unread badge). vg-binding: PLAN:task-38 / PLAN:task-40 / P6.D-06 / P6.D-118 / P6.D-119 / P6.D-120 / P6.D-121 / P6.D-174 / P6.D-225 / G-63 / G-65 / G-66",
    "title": "Notification preferences",
    "save": "Save preferences",
    "loadMore": "Load more",
    "unread": "Unread",
    "nav": {
      "label": "Notifications"
    },
    "center": {
      "title": "Notification Center"
    },
    "settings": {
      "title": "Notification settings",
      "category": {
        "orders": "Order updates",
        "shipping": "Shipping updates",
        "payment": "Payment",
        "wallet": "Wallet",
        "billing": "Billing",
        "system": "System announcements",
        "marketing": "Marketing"
      }
    },
    "tab": {
      "all": "All",
      "orders": "Orders",
      "products": "Products",
      "stores": "Stores",
      "wallet": "Wallet",
      "system": "System",
      "billing": "Billing"
    },
    "filter": {
      "unreadOnly": "Unread only"
    },
    "bulk": {
      "markAllRead": "Mark all as read",
      "markAllReadError": "Couldn't mark all as read. Please try again."
    },
    "item": {
      "viewDetail": "View detail"
    },
    "empty": {
      "title": "No notifications yet",
      "subtitle": "When new updates land for your orders, wallet or stores, you will see them here."
    },
    "group": {
      "today": "Today",
      "yesterday": "Yesterday",
      "earlier": "Earlier"
    },
    "column": {
      "category": "Category"
    },
    "category": {
      "orders": "Order updates",
      "shipping": "Shipping updates",
      "payment": "Payment",
      "wallet": "Wallet",
      "billing": "Billing",
      "system": "System announcements",
      "marketing": "Marketing"
    },
    "channel": {
      "email": "Email",
      "push": "Push",
      "inApp": "In-app"
    },
    "sound": {
      "label": "In-app notification sound",
      "help": "Play a short chime when a new notification arrives.",
      "on": "On",
      "off": "Off"
    },
    "detail": {
      "notFound": "Notification not found.",
      "back": "Back to notifications",
      "emptyBody": "No detailed content."
    }
  },
  "dashboard": {
    "_comment": "Phase 6 Wave 12 Task 41 — Dashboard surface (KPI strip + Getting Started + Quick Actions + Recent Orders + Top Products + Activity Feed + Growth placeholder + 5-step Onboarding wizard). vg-binding: PLAN:task-41 / P6.D-07..14 / G-67 / G-68",
    "title": "Dashboard",
    "kpi": {
      "todayRevenue": "Today's revenue",
      "activeOrders": "Active orders",
      "walletBalance": "Wallet balance",
      "pendingTopups": "Pending top-ups",
      "deltaUp": "up",
      "deltaDown": "down"
    },
    "gettingStarted": {
      "title": "Getting started",
      "progress": "{{pct}}% complete",
      "hideForever": "Hide forever",
      "step": {
        "connectStore": "Connect your first store",
        "addProduct": "Add your first product",
        "branding": "Configure branding",
        "setup2fa": "Setup two-factor authentication",
        "topupWallet": "Top up your wallet",
        "inviteTeam": "Invite a team member",
        "setupNotifications": "Setup notification preferences",
        "firstOrder": "Place your first order"
      }
    },
    "quickActions": {
      "title": "Quick actions",
      "action": {
        "createOrder": "Create order",
        "createOrder.subtext": "New order or import",
        "connectStore": "Connect store",
        "connectStore.subtext": "Shopify, Woo, TikTok",
        "topupWallet": "Top up wallet",
        "topupWallet.subtext": "Add funds for fulfillment",
        "viewReports": "View reports",
        "viewReports.subtext": "Payment + invoice history"
      }
    },
    "recentOrders": {
      "title": "Recent orders",
      "empty": "No orders yet — your first order will appear here.",
      "status": {
        "draft": "Draft",
        "pending": "Pending",
        "processing": "Processing",
        "shipped": "Shipped",
        "delivered": "Delivered",
        "cancelled": "Cancelled",
        "issues": "Issues"
      }
    },
    "topProducts": {
      "title": "Top products",
      "unitsSold": "units",
      "empty": "No sales yet in the last 30 days.",
      "viewAll": "View all"
    },
    "activityFeed": {
      "title": "Recent activity",
      "empty": "No recent activity yet."
    },
    "growth": {
      "placeholder": {
        "badge": "Mock data",
        "title": "Growth insights coming soon",
        "cta": "GMV progress, loyalty tier and active campaigns will land here in Phase 10."
      }
    },
    "onboarding": {
      "welcome": {
        "title": "Welcome to Printway",
        "subtitle": "A short 5-step setup to get your merchant account ready."
      },
      "step": {
        "businessType": "Choose your business type",
        "connectStore": "Connect your first store",
        "addProduct": "Add your first product",
        "done": "You're all set"
      },
      "businessType": {
        "pod": "Print on Demand",
        "pod.subtext": "Sell custom-printed apparel, mugs and more.",
        "general": "General store",
        "general.subtext": "General catalog with mixed products."
      },
      "connectStore": {
        "subtitle": "Hook up Shopify, WooCommerce or TikTok Shop in one click.",
        "cta": "Open store connector"
      },
      "addProduct": {
        "subtitle": "Browse the catalog and create your first published product.",
        "cta": "Open product wizard"
      },
      "done": {
        "subtitle": "You're all set — let us drop you on the dashboard."
      },
      "next": "Next",
      "back": "Back",
      "skip": "Skip for now",
      "complete": "Go to dashboard"
    },
    "subtitle": "Here's what's happening with your print-on-demand business.",
    "welcome": "Welcome back!",
    "welcomeNamed": "Welcome back, {{name}}!"
  },
  "myProducts": {
    "columns": {
      "thumbnail": "Image",
      "name": "Name",
      "category": "Category",
      "sync": "Sync",
      "created": "Created",
      "lastModified": "Modified",
      "actions": "Actions"
    },
    "delete": {
      "success": "Deleted \"{{name}}\"",
      "failed": "Delete failed"
    }
  },
  "a11y": {
    "_comment": "Phase 6 i18n batch M3 — aria-label sweep. vg-binding: P6.D-131 / P6.D-221 / dbg-20260519-203958-merchant-i18n",
    "pagination": "Pagination",
    "firstPage": "First page",
    "previousPage": "Previous page",
    "nextPage": "Next page",
    "lastPage": "Last page",
    "openProfileMenu": "Open profile menu",
    "loadingPage": "Loading page",
    "promoBanner": "Promo banner",
    "dismissPromoBanner": "Dismiss promo banner",
    "expandSidebar": "Expand sidebar",
    "collapseSidebar": "Collapse sidebar",
    "dismissNotification": "Dismiss notification",
    "productEditorTabs": "Product editor tabs",
    "close": "Close",
    "storeDisconnected": "No store connected",
    "storeSyncStatus": "Sync status per store",
    "bulkActions": "Bulk actions",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "remove": "Remove",
    "breadcrumb": "Breadcrumb",
    "primaryNavigation": "Primary navigation",
    "openNavigation": "Open navigation",
    "artworkGrid": "Artwork grid",
    "clear": "Clear",
    "clearSearch": "Clear search",
    "removeLine": "Remove line",
    "statementsChart": "Statements chart",
    "spendingChart": "Spending chart",
    "range": "Range",
    "primaryColorHex": "Primary color hex",
    "secondaryColorHex": "Secondary color hex",
    "onboardingProgress": "Onboarding progress",
    "orderDetailSections": "Order detail sections",
    "public": "Public",
    "private": "Private",
    "removeRule": "Remove rule",
    "orderStatusTabs": "Order status tabs",
    "required": "Required",
    "decreaseQuantity": "Decrease quantity",
    "increaseQuantity": "Increase quantity",
    "decrease": "Decrease",
    "increase": "Increase",
    "settingsSections": "Settings sections",
    "teamMemberDetailTabs": "Team member detail tabs",
    "walletSubNavigation": "Wallet sub navigation",
    "instantGateways": "Instant gateways",
    "selectAllRows": "Select all rows",
    "selectRow": "Select row {{id}}",
    "skipToMain": "Skip to main content",
    "backToTop": "Back to top",
    "openHelpMenu": "Open help menu"
  },
  "placeholder": {
    "_comment": "Phase 6 i18n batch M3 — placeholder sweep. vg-binding: P6.D-131 / P6.D-221 / dbg-20260519-203958-merchant-i18n",
    "url": "https://…",
    "productSlug": "my-awesome-product",
    "sku": "SKU…",
    "storeIds": "store_1, store_2",
    "categoryIds": "apparel, drinkware",
    "emailExample": "email@example.com",
    "expDate": "MM/YY",
    "cardHolderName": "John Doe",
    "fnsku": "X00ABCDEFG",
    "countryCode": "US",
    "skuPrefix": "SKU-",
    "timezone": "UTC",
    "shopifyDomain": "your-shop.myshopify.com",
    "shopUrl": "https://shop.example.com",
    "merchantEmail": "merchant@example.com",
    "opsEmail": "ops@example.com"
  },
  "placeholders": {
    "_comment": "Phase 6 i18n batch M4 — PlaceholderPage stub titles. vg-binding: P6.D-131 / P6.D-221 / dbg-20260519-203958-merchant-i18n",
    "_fallback": {
      "title": "...",
      "description": "Placeholder — real page lands in a later wave."
    },
    "dashboard": {
      "title": "Dashboard"
    },
    "artworkLibrary": {
      "title": "Artwork Library"
    },
    "invoiceDetail": {
      "title": "Invoice Detail"
    },
    "invoices": {
      "title": "Invoices"
    },
    "notifications": {
      "title": "Notifications"
    },
    "onboarding": {
      "title": "Onboarding"
    },
    "orderCreate": {
      "title": "Create Order"
    },
    "orderDetail": {
      "title": "Order Detail"
    },
    "orderImport": {
      "title": "Import Orders"
    },
    "orders": {
      "title": "Orders"
    },
    "productCreate": {
      "title": "Create Product"
    },
    "productDetail": {
      "title": "Product Detail"
    },
    "settingsBranding": {
      "title": "Branding"
    },
    "settingsProfile": {
      "title": "Profile"
    },
    "storeDetail": {
      "title": "Store Detail"
    },
    "stores": {
      "title": "Store Settings"
    },
    "storesSyncLogs": {
      "title": "Sync Logs"
    },
    "support": {
      "title": "Support"
    },
    "team": {
      "title": "Team"
    },
    "wallet": {
      "title": "Wallet"
    },
    "walletTopup": {
      "title": "Wallet Top-up"
    },
    "walletTransactions": {
      "title": "Wallet Transactions"
    }
  },
  "search": {
    "placeholder": "Search…",
    "empty": "No results",
    "moreHint": "+{{count}} more — type to search"
  },
  "profile": {
    "guest": "Guest",
    "account": "Account",
    "notSignedIn": "Not signed in"
  },
  "breadcrumb": {
    "import": "Import",
    "artwork": "Artwork Library",
    "topup": "Top-up",
    "transactions": "Transactions",
    "onboarding": "Onboarding",
    "login": "Sign in",
    "home": "Home",
    "detail": "Detail",
    "paymentMethods": "Payment Methods",
    "paymentRequests": "Payment Requests",
    "backToBilling": "← Back to Billing"
  },
  "bulkUpload": {
    "errorMalformedResponse": "Malformed upload response — see network log.",
    "errorHttpStatus": "Upload failed (HTTP {{status}})",
    "dropPrompt": "Drag a CSV here, or",
    "browseFile": "choose a file",
    "selectedLabel": "Selected:",
    "uploading": "Uploading…",
    "upload": "Upload",
    "successCount": "{{n}} succeeded",
    "failureCount": "{{n}} failed",
    "totalRows": "of {{total}} rows",
    "viewErrorDetails": "View error details ({{n}})",
    "rowLabel": "Row {{row_num}}"
  },
  "timezone": {
    "autoDetect": "Auto-detect ({{tz}})"
  },
  "common": {
    "loading": "Loading…",
    "cancel": "Cancel",
    "close": "Close",
    "pagination": {
      "pageOf": "Page {{page}} of {{total}}"
    }
  },
  "badge": {
    "featured": "Featured"
  },
  "detail": {
    "blueprint": "Blueprint",
    "metaDescription": "Meta description",
    "metaTitle": "Meta title",
    "seo": "SEO",
    "size": "Size",
    "edit": "Edit",
    "media": "Media",
    "noImage": "No image",
    "primary": "Primary",
    "general": "General",
    "category": "Category",
    "blueprintVersion": "Blueprint version",
    "createdAt": "Created at",
    "updatedAt": "Updated at",
    "tags": "Tags",
    "variants": "Variants",
    "color": "Color",
    "priceOverride": "Price override",
    "inventory": "Inventory",
    "state": "State",
    "retired": "Retired",
    "activeVariant": "Active",
    "pricingPerStore": "Pricing per store",
    "store": "Store",
    "sellingPrice": "Selling price",
    "baseCost": "Base cost (system → merchant)"
  },
  "help": {
    "announcements": "Announcements",
    "contact": "Contact support",
    "docs": "Documentation"
  },
  "notif": {
    "email": {
      "master": "Enable email notifications",
      "test": "Test",
      "testSent": "Sent",
      "title": "Email Notifications"
    },
    "inApp": {
      "days": "{{count}} days",
      "retention": "Keep notifications for:",
      "sound": "Enable notification sounds",
      "soundHelp": "Play a short chime when a new notification arrives.",
      "title": "In-App Notifications"
    },
    "notVerified": "Not verified",
    "push": {
      "blocked": "Blocked",
      "deniedHelp": "Push is blocked in your browser settings. Re-enable it there first.",
      "enabled": "Enabled",
      "help": "Show desktop alerts even when this tab is in the background.",
      "master": "Enable browser push notifications",
      "notRequested": "Not requested",
      "title": "Push Notifications",
      "unsupported": "Unsupported",
      "unsupportedHelp": "Your browser does not support push notifications.",
      "inactive": "Not enabled on this device",
      "activeHelp": "This browser will receive wallet alerts even when the tab is in the background.",
      "unconfigured": "Push is not configured on this server yet.",
      "error": "Could not update push settings. Please try again.",
      "working": "Updating…"
    },
    "quiet": {
      "end": "End",
      "master": "Enable quiet hours (no notifications during this time)",
      "start": "Start",
      "title": "Quiet Hours"
    },
    "sms": {
      "codeLabel": "Enter the 6-digit code we sent you",
      "help": "Verify your phone number to receive SMS notifications.",
      "invalidCode": "Invalid code.",
      "master": "Enable SMS notifications",
      "title": "SMS Notifications",
      "verifyCode": "Verify",
      "verifyPhone": "Verify Phone"
    },
    "verified": "Verified"
  },
  "pagination": {
    "of": "of",
    "rowsPerPage": "Rows per page",
    "showing": "Showing"
  },
  "shipments": {
    "trackRouting": {
      "alerts": {
        "ageDays": "+{{days}} days",
        "collapse": "Collapse alerts",
        "empty": "No alerts.",
        "expand": "Expand alerts",
        "openExternal": "Open details",
        "summary": "{{critical}} critical, {{warnings}} warnings",
        "title": "Shipment Alerts",
        "view": "View"
      },
      "cards": {
        "on_time_rate": {
          "sub": "{{numerator}} / {{denominator}} shipments"
        },
        "active_time": {
          "label": "Active Time",
          "sub": "{{count}} shipments · avg {{avgHrs}} · max {{maxHrs}}"
        },
        "last_mile_time": {
          "label": "Last-Mile Time",
          "sub": "{{count}} shipments · avg {{avgHrs}} · max {{maxHrs}}"
        }
      },
      "dashboardTitle": "SLA Performance Dashboard",
      "pagination": {
        "next": "Next page",
        "prev": "Previous page",
        "show": "Show",
        "total": "Total: {{total}}"
      },
      "statusOverview": {
        "title": "Shipment Status Overview"
      },
      "subtitle": "Monitor SLA performance and track all shipments",
      "table": {
        "columns": {
          "firstScan": "First Scan",
          "delivered": "Delivered"
        },
        "delayDays": "+{{days}} days delayed",
        "deliveredPrefix": "Delivered",
        "empty": "No shipments match the active filter.",
        "openExternal": "Open tracking link",
        "slaDays": "{{days}}d",
        "viewAction": "View details",
        "notShipped": "—"
      },
      "title": "Track Routing",
      "toolbar": {
        "allCarriers": "All Carriers",
        "allStatuses": "All Statuses",
        "searchPlaceholder": "Search by tracking number or order…"
      },
      "window": {
        "7d": "7 days",
        "30d": "30 days",
        "90d": "90 days",
        "aria": "SLA metrics window"
      },
      "dashboardEmpty": "No data in this window",
      "emptyBanner": {
        "title": "No SLA tracking data yet",
        "description": "SLA timing metrics appear once carriers report package scans for shipments in this window."
      }
    }
  },
  "sidebar": {
    "categories": "Categories",
    "filters": "Filters",
    "max": "Max",
    "min": "Min",
    "priceRange": "Price range"
  },
  "twoFA": {
    "challengeSubtitle": "Enter the 6-digit code from your authenticator app to authorise this action.",
    "challengeTitle": "Confirm with two-factor authentication",
    "code": "6-digit code",
    "codeFormat": "Enter the 6-digit code from your authenticator app.",
    "codeLabel": "6-digit code",
    "confirm": "Confirm",
    "error": "Invalid code",
    "errorLength": "Code must be exactly 6 digits",
    "locked": "2FA temporarily locked after too many failed attempts. Try again later.",
    "title": "2FA verify",
    "verify": "Verify",
    "notEnrolledTitle": "2FA not enabled",
    "notEnrolledDesc": "Withdrawals require two-factor authentication. Please enable 2FA first.",
    "goToSetup": "Go to security settings →"
  },
  "wizard": {
    "breadcrumbEdit": "My Products / Edit Product",
    "pageTitleEdit": "Edit product",
    "step2": {
      "col": {
        "customSku": "Custom SKU"
      },
      "customSkuHint": "Optional. Leave blank to reuse the system SKU when matching orders.",
      "customSkuDup": "Custom SKU is duplicated — it must be unique within the product."
    },
    "step3": {
      "libraryEmpty": "Your library is empty.",
      "libraryEmptyHint": "Upload a file via the drag-drop area below — it will appear here next time.",
      "libraryLoadFailed": "Could not load your library. Try again.",
      "libraryTitle": "Choose from library"
    },
    "step5": {
      "cards": {
        "mainMissing": "not selected",
        "mainSet": "selected",
        "mockup": "Mockup",
        "mockupCount": "{{count}} image(s) · main image {{main}}",
        "mockupEmpty": "No images uploaded"
      }
    },
    "nav": {
      "saving": "Saving…",
      "saveChanges": "Save changes"
    }
  },
  "mode": "edit",
  "step": "variants",
  "retry": "1",
  "read": "unread",
  "limit": "20",
  "editor": {
    "actions": {
      "saved": "Product saved",
      "saveFailed": "Save failed",
      "noChanges": "No changes to save"
    }
  },
  "info": "Artwork moved to {{folder}}",
  "error": "Could not move artwork. Please try again."
}
